import { LocalStorageService } from './../../_services/local-storage.service';
import { Router } from '@angular/router';
import { SearchtoolboxService } from './../../_services/searchtoolbox.service';
import { CandidateService } from './../../_services/candidate.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl, UntypedFormArray, AbstractControl, FormBuilder } from '@angular/forms';
import { CandidateEmailComponent } from './../candidate-email/candidate-email.component';
import { CallLogComponent } from './../call-log/call-log.component';
import { CandidateNoteComponent } from './../candidate-note/candidate-note.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, ViewChild, TemplateRef, Input, ElementRef, Output, EventEmitter } from '@angular/core';
import { GlobalService } from 'src/app/_services/global.service';
import { Observable, of, Subject } from 'rxjs';
import moment from 'moment';
import { SearchCountryField, CountryISO } from 'ngx-intl-tel-input';
import * as _ from 'underscore';
import { TransactionService } from 'src/app/_services/transaction.service';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { AddToTalentpoolComponent } from 'src/app/talentpool/add-to-talentpool/add-to-talentpool.component';
import { MatAutocompleteTrigger as MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { I } from '@angular/cdk/keycodes';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import * as __ from 'lodash';
import { WebbtreeVerifiedService } from 'src/app/_services/webbtree-verified.service';
import { CampaignService } from 'src/app/_services/campaign.service';
import { BulkRevealModalComponent } from 'src/app/bulk-reveal-modal/bulk-reveal-modal.component';
import { AddEditExperienceModalComponent } from 'src/app/add-edit-experience-modal/add-edit-experience-modal.component';
import { EducationModalComponent } from 'src/app/education-modal/education-modal.component';
import { AtsResumeScreenService } from 'src/app/_services/ats-resume-screen.service';
import { debounceTime, distinctUntilChanged, switchMap, takeUntil } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { AddCandidateAegisModalComponent } from 'src/app/person-search-listing/add-candidate-aegis-modal/add-candidate-aegis-modal.component';
import { AegisIntegrationService } from 'src/app/_services/aegisIntegration.service';

declare const clevertap;

@Component({
    selector: 'app-candidate-slider',
    templateUrl: './candidate-slider.component.html',
    styleUrls: ['./candidate-slider.component.scss'],
    standalone: false
})
export class CandidateSliderComponent implements OnInit {
  basicdetails: any;
  additionaldetails: any = [];
  educationdetails: any;
  experiencedetails: any;
  experienceid: any;
  educationid: any;
  candidateid: any;
  successMessage: string;
  errorMessage: string;
  deleteExperienceID: any;
  deleteEducationID: any;
  iscurrent: any = 0;
  skillerror: boolean;
  showAllDetails: boolean;
  showExperienceDetails: boolean;
  showAdditionalDetails: boolean;
  showEducationDetails: boolean;
  showBasicDetails: boolean;
  showEditContacts: boolean;
  candidate_form: UntypedFormGroup;
  experience_form: UntypedFormGroup;
  education_form: UntypedFormGroup;
  contact_form: UntypedFormGroup;
  additionaldetails_form: UntypedFormGroup;
  year_list = GlobalService.yearList()
  skillsdata: any[] = [];
  skills: any;
  skillsarraylist: any;
  jobtitlearraylist: any;
  locationarraylist: any;
  companyarraylist: any;
  skillsList: any;
  joblist: any;
  companylist: any;
  locationlist: any;
  Degreesarraylist: any;
  schoolnamearraylist: any;
  degreelist: string[];
  schoollist: string[];
  CallLogActivities: any;
  tabtoShow: any;
  contactdetails: any;
  contactnumbers: any = [];
  emails: any;
  socialprofiles: any[] = [];
  emailsdetails: any = [];
  linkedin: any[] = [];
  facebook: any[] = [];
  angel: any[] = [];
  behance: any[] = [];
  website: any[] = [];
  other: any[] = [];
  twitter: any[] = [];
  github: any[] = [];
  reddit: any[] = [];
  instagram: any[] = [];
  aboutme: any[] = [];
  google: any[] = [];
  quora: any[] = [];
  youtube: any[] = [];
  flickr: any[] = [];
  foursquare: any[] = [];
  educationOldOBj: any;
  experienceOldOBj: any;
  SkillsOldOBj: any;
  editsocialprofiles: any[] = [{ sociallinks: '' }];
  premium_found: boolean = true
  @Input() events: Observable<void>;
  @ViewChild('deleteexperience') deleteexperience: TemplateRef<any>;
  @ViewChild('deleteeducation') deleteeducation: TemplateRef<any>;
  @ViewChild('deletecandidate') deletecandidate: TemplateRef<any>;
  @ViewChild('noCreditsCE') noCreditsCE: TemplateRef<any>;
  @ViewChild('deletelink') deletelink: TemplateRef<any>;
  @ViewChild('deletemail') deletemail: TemplateRef<any>;
  @ViewChild('deletecontact') deletecontact: TemplateRef<any>;
  @ViewChild('detailsslider') detailsslider: ElementRef<HTMLElement>;
  @ViewChild('contactslider') contactslider: ElementRef<HTMLElement>;
  @ViewChild('notesslider') notesslider: ElementRef<HTMLElement>;
  @ViewChild('fileslider') fileslider: ElementRef<HTMLElement>;

  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;

  gravatar: any[] = []
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  socialprofilesdata: any[] = [];
  emailsdata: any[] = [];
  contactdata: any[] = [];
  deleteSocialLinkindex: any;
  deleteSocialLinkID: any;
  deleteEmaildID: any;
  deleteEmailIndex: any;
  deleteContactID: any;
  deleteContactIndex: any;
  autocomplete_company: boolean = true
  allcandidatedetails: any;
  premiumenrichmentstatus: any;
  isteamMember: boolean;
  subscriptiondetails: any = {};
  viewmorenumber: boolean;
  viewmoreEmails: boolean;
  viewmoreLinks: boolean;
  pinterest: any[] = [];
  stackoverflow: any[] = [];
  dribbble: any[] = [];
  totalcontacts_from_pdl: any;
  moreAvailableContactDetails: { socialprofiles: any; emails: any[]; contactnumbers: any[]; };

  moreavaibledetails: any = []
  contactdetail: any
  existingContactDetails: any
  changebluebg: boolean = false
  linkedin_url: any
  facebook_url: any
  twitter_url: any
  github_url: any
  tagList: any
  tagtext: string = ''
  tagArray: any = []
  tagmessage: string
  option: string;
  candidateelasticid: any
  pdlresp: any
  signalhireresp: any
  nymblrresp: any
  revealerror: boolean = false
  personalemails: any
  professionalemails: any
  tags: any
  tagchips: any = []
  sendtagarray: any = []
  @Output() refreshCandidateListEvent: EventEmitter<any> = new EventEmitter();
  // @Output() refreshContactDetailEvent: EventEmitter<any> = new EventEmitter();
  dataproviders: any
  tagmore: boolean = false
  uniqueEnrichedvia: any[] = []
  hideelement: boolean = false
  hideRevealContact: boolean = true;
  allContactProviders: any[] = [];
  candidateNumber: any;
  isExtensioninstalled: any;

  currentUser: any = null;
  @ViewChild('addCandidateToEmailCampaign') addCandidateToEmailCampaign: TemplateRef<any>;
  @Output() openModalEvent = new EventEmitter<void>();
  @ViewChild('addCandidateToScreenAiModal') addCandidateToScreenAiModal: TemplateRef<any>;
  emailFoundCount: number;
  campaignList: any;
  selectedCampaign: any;
  campaign_input = new UntypedFormControl(null, [Validators.required]);
  candidateIdentifier: number | null;
  enrichedfrom: string = 'talentpool'

  showAllDivData:Boolean = false;
  showSuccessfulData:Boolean = false;
  showRequestSpinner:Boolean = false;
  selectedInputValues: String[] = []
  personalContactChecked: Boolean = false
  personalEmailChecked: Boolean = false
  colvillform: UntypedFormControl = new UntypedFormControl(null)

  /**For contact tab */
  isPreviewApiCalled:boolean = false;
  /** For Profile Tab*/
  isProfileTabCalled:boolean = false;

  showAllDivDataWebbtreeIntro: boolean;
  showSuccessfulDataWebbtreeIntro: boolean;
  webbtreeIntroForm: UntypedFormControl = new UntypedFormControl(null);
  showwebbtreeintrospinner: boolean
  isWebbtreeIntroductionChecked: Boolean = false;
  canShowProvidersList: boolean = false;
  showProfileLoader: boolean = false;
  interestDetails: any[] = [];
  tagErrorMessage: string = '';

  candidateContactObj: any = {};
  callContactSlider:boolean = false;
  bulkRevealContactStatus: any;

    /** To know the pending status of api*/
    isLoadingEmailCampaignApi: boolean = false;
    @Output() revealStatusEventEmitter: EventEmitter<any> = new EventEmitter();
          @ViewChild('addToEmailCampaignWithViewCampaign') addToEmailCampaignWithViewCampaign: TemplateRef<any>;
  campaignName: string = '';

  job_input= new UntypedFormControl(null, [Validators.required]);

  jobList: any[] = [];
  selectedJob: any = null;

  // ScreenAI modal state
  screenAiDuplicateCheckDone: boolean = false;
  isLoadingScreenAiApi: boolean = false;
  postAddMssg: string = '';
  addCandidateSuccess: boolean = false;
  private destroy$ = new Subject<void>();


  /** Candidate certificat data */
  certificationDetails:any = [];
    reverseComponentSubject: Subject<any> = new Subject();

  candidateData: any = {};
  aegisCandidateData: any = null;
  isAegisConnected: boolean = false;

  constructor(public requestContract: WebbtreeVerifiedService, public modalService: NgbModal, private fb: FormBuilder, public candidateservice: CandidateService, private searchtoolbox: SearchtoolboxService,
    public router: Router, private _localstorageservice: LocalStorageService, private atsResumeScreenService: AtsResumeScreenService, private transactionservice: TransactionService, private sanitization: DomSanitizer, private personSearchService: PersonSearchService, private emailCampaignService: CampaignService,
    private aegisIntegrationService: AegisIntegrationService) {
      this.currentUser = parseInt(this._localstorageservice.getItem('userid') || 0);
    }

  ngOnInit() {
    this.checkAegisIntegrationConnected();
    this.contact_form = this.fb.group({
      sociallinks: this.fb.array([]),
      contactemails: this.fb.array([]),
      phonenumber: this.fb.array([]),
    })

    this.tagErrorMessage = '';
    this.events.subscribe((event: any) => {
      this.premium_found = true
      this.candidateid = event.candidatenumber
      this.candidateelasticid = event.elasticid
      this.candidateIdentifier = event.candidateId;
      //this.tabtoShow = event.tabtoShow
      // this.getautocompleteData()
      this.isPreviewApiCalled = false;
      this.isProfileTabCalled = false;
      this.bulkRevealContactStatus = event.bulkContactStatus;
      console.log("Bulk reveal contact status in slider", this.bulkRevealContactStatus)
         /**
          * Profile viewed CT event
          */
          const profileParams = {
            "User ID": this._localstorageservice.getItem('userdata').userid,
            "Candidate ID": this.candidateid,
            "Timestamp": moment().format()
          }
          clevertap.event.push('Profile Viewed', profileParams);
      this.showAllDetail(event.tabtoShow);
    })

    this.campaign_input.valueChanges.subscribe((value) => this.onTypeAheadSearch(value));
      // document.onclick = function(event) {
      //     console.log(event)
      //     const target = event.target as HTMLElement;
      //     console.log(event)
      //     if (!target.className.includes('fa-solid fa-plus')) {
      //       console.log("tesrr")
      //       document.getElementById('dropdowndata').style.display = 'none'

      //     }
      //   }
       if(this.router.url && this.router.url.includes('candidate-list')){
           this.enrichedfrom = 'all-candidates'
       }

       this.getAllScreenAIJobs();
       /**
        * This handles search with debouncing for screenai jobs
        */
       this.job_input.valueChanges
        .pipe(
          debounceTime(200),
          distinctUntilChanged(),
          switchMap((query: string) => {
            const q = (query || '').trim();
            return this.atsResumeScreenService.getAllScreenAIJobsBySource(q, 'create');
          }),
          takeUntil(this.destroy$)  // prevent memory leak
        )
        .subscribe((res: any) => {
          // Handle both the empty array shortcut and API response
          if (Array.isArray(res)) {
            this.jobList = res;
            return;
          }
          if (res.status === 'success') {
            this.jobList = res.data || [];
          }
        });


      }

  /**
   * Checks if the Aegis integration is connected by calling the Aegis integration service.
   */
  checkAegisIntegrationConnected() {
    this.aegisIntegrationService.checkAegisIntegrationConnected().subscribe((response: any) => {
      if (response && response.body && response.body?.success) {
        this.isAegisConnected = true;
      } else {
        this.isAegisConnected = false;
      }
    }, (error) => {
      this.isAegisConnected = false;
    });
  };

  /**
   * Opens the AddCandidateAegisModalComponent modal and passes the selected candidates to it.
   * @param data The data of the candidate to be added to Aegis.
   */
  addToAegis() {
    const modalRef = this.modalService.open(AddCandidateAegisModalComponent, { size: 'lg' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.candidates = this.candidateData ? [this.candidateData] : [];
    modalRef.componentInstance.calledfrom = 'talentpool';
    modalRef.componentInstance.update.subscribe((result: { status: 'success' | 'error', message: string, data: any }) => {
      if (result.status === 'success') {
        this.aegisCandidateData = result.data?.taggedCandidate || null;
        const res = result.data?.createdCandidate ? result.data.createdCandidate : result.data;
        const successCount = res?.successful || 0;
        const duplicateCount = res?.duplicate || 0;
        const failedCount = res?.unsuccessful || 0;
        const totalCount = successCount + duplicateCount + failedCount;
        if (totalCount > 0) {
          if (successCount > 0 && duplicateCount > 0 && failedCount > 0) {
            this.successMessage = `Processed ${totalCount} candidate(s): ${successCount} added successfully, ${duplicateCount} skipped as duplicates, and ${failedCount} could not be added due to insufficient information.`;
          } else if (successCount && duplicateCount > 0 && !failedCount) {
            this.successMessage = `Processed ${totalCount} candidate(s): ${successCount} added successfully, ${duplicateCount} skipped as duplicates.`;
          } else if (successCount && !duplicateCount && !failedCount) {
            this.successMessage = `${successCount} Candidate Tagged Successfully`;
          } else if (!successCount && duplicateCount && !failedCount) {
            this.errorMessage = `${duplicateCount} Candidate duplicate found in Aegis`;
          } else if (!successCount && !duplicateCount && failedCount) {
            this.errorMessage = `${failedCount} Candidate could not be added due to insufficient information.`;
          } else {
            this.errorMessage = `No candidates were tagged to Aegis. Please try again.`;
          }
        } else {
          this.successMessage = `No candidates were tagged to Aegis.`;
        }
      } else if (result.status === 'error') {
        const res = result.data?.createdCandidate ? result.data.createdCandidate : result.data;
        const successCount = res?.successful || 0;
        const duplicateCount = res?.duplicate || 0;
        const failedCount = res?.unsuccessful || 0;
        const totalCount = successCount + duplicateCount + failedCount;
        if (totalCount > 0) {
          if (successCount > 0 && duplicateCount > 0 && failedCount > 0) {
            this.successMessage = `Processed ${totalCount} candidate(s): ${successCount} added successfully, ${duplicateCount} skipped as duplicates, and ${failedCount} could not be added due to insufficient information.`;
          } else if (successCount && duplicateCount > 0 && !failedCount) {
            this.successMessage = `Processed ${totalCount} candidate(s): ${successCount} added successfully, ${duplicateCount} skipped as duplicates.`;
          } else if (successCount && !duplicateCount && !failedCount) {
            this.successMessage = `${successCount} Candidate Tagged Successfully`;
          } else if (!successCount && duplicateCount && !failedCount) {
            this.errorMessage = `${duplicateCount} Candidate duplicate found in Aegis`;
          } else if (!successCount && !duplicateCount && failedCount) {
            this.errorMessage = `${failedCount} Candidate could not be added due to insufficient information.`;
          } else {
            this.errorMessage = `No candidates were tagged to Aegis. Please try again.`;
          }
        } else {
          this.errorMessage = `Failed to tag candidates to mandate. Please try again.`;
        }
      } else if (result.status === 'unauthorized') {
        this.errorMessage = result.message;
      }
      this.modalService.dismissAll();
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 5000);
    });
  };


  /**
   * Check if candidate exist in Aegis
   */
  checkCadidateExistInAegis(response: any) {
    const basicData = response.basicdetails[0];
    const payload = {
      "personalemail": basicData.primaryemailid,
      "personalmobile": basicData.primarycontactnumber,
      "firstname": basicData.firstname,
      "lastname": basicData.lastname,
      "jobtitle": basicData.jobtitle && basicData.companyname ? basicData.jobtitle : this.getCandidateCurrentExperience(response.experiencedetails).currentjobtitle,
      "currentcompany": basicData.companyname && basicData.jobtitle ? basicData.companyname : this.getCandidateCurrentExperience(response.experiencedetails).currentcompany,
      "linkedin": basicData.profileurl
    };


    this.aegisIntegrationService.checkCandidateExistInAegis(payload).subscribe((res: any) => {
      if (res && res.body && res.body?.success && res.body.data && res.body.data.status === 'success') {
        this.aegisCandidateData = res.body.data.data;
      } else {
        this.aegisCandidateData = null;
      };
    }, (err) => {
      this.aegisCandidateData = null;
    });
  };


  getCandidateCurrentExperience = (candidateExp) => {
    if (!candidateExp || !candidateExp.length) {
        return {
            currentjobtitle: null,
            currentcompany: null
        };
    };

    const data = {
        currentjobtitle: null,
        currentcompany: null
    }

    /**
     * Logic to get current experience:
     * 1. Filter the experience array to get only the current experience (where iscurrent == 1).
     * 2. If there are multiple current experiences, sort them by start date in descending order and take the first one as the most recent current experience.
     * 3. If there is no current experience, sort all experiences by start date in descending order and take the first one as the most recent experience to populate current job title and company.
     */
    const currentExperience = candidateExp.filter(x => x.iscurrent == 1);
    if (currentExperience.length > 0) {
        const sortedCurrentExp = currentExperience.sort((a, b) => {
            const dateA = new Date(a.startdate).getTime();
            const dateB = new Date(b.startdate).getTime();
            return dateB - dateA;
        });

        data.currentjobtitle = sortedCurrentExp[0].jobtitle || null;
        data.currentcompany = sortedCurrentExp[0].companyname || null;
    } else {
        const sortedAllExp = candidateExp.sort((a, b) => {
            const dateA = new Date(a.startdate).getTime();
            const dateB = new Date(b.startdate).getTime();
            return dateB - dateA;
        });

        if (sortedAllExp.length > 0) {
            data.currentjobtitle = sortedAllExp[0].jobtitle || null;
            data.currentcompany = sortedAllExp[0].companyname || null;
        }
    };

    return data;
};

  /**
   * Format date in required format
   * @param dateString
   * @returns
   */
  getFormatedDate(dateString: string) {
    const date = GlobalService.getDates(dateString);
    return date;
  };

 forwardEvent() {
    this.openModalEvent.emit();
  }
  moment = moment;

  get isCurrentUserTheCreator() {
    return (this.currentUser == this.basicdetails?.actualuserid);
  }

  ngOnDestroy(): void {
  this.destroy$.next(undefined as any);
  this.destroy$.complete();
}


  getautocompleteData(type, input): Observable<any> {
    let data = {
      "dropdowntype": type,
      "searchedstring": input
    }
    var subject = new Subject<any>();
    this.searchtoolbox.getAutoCompleteDataList(data).subscribe((res: any) => {
      if (res.status == 'success') {
        subject.next(res.data);
      } else {
        subject.next([])
      }
    })
    return subject.asObservable();
  }

  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }

  showfreecontactdetails() {
    if (!(this.subscriptiondetails.balancebasiccontactenrichmentcredits > 0 || this.subscriptiondetails.balancebasiccontactenrichmentcredits == -1)) {
      let ctObj = {
        "Name": this.basicdetails.firstname + " " + this.basicdetails.lastname,
        "Job title": this.basicdetails.jobtitle,
        "Company Name": this.basicdetails.companyname,
        "Source": this.basicdetails.source,
        "Location": this.basicdetails.locationname,
        "Origin": "Web app",
        "Profile URL": this.basicdetails.profileurl
      }
      setTimeout(() => this.cleverTapEvent("ContactEnrich_CreditExhausted", ctObj), 1000);
      this.router.navigateByUrl('/subscription/pricing')
    } else {
      let data = {
        "candidatenumber": this.candidateid,
        "usernumber": this._localstorageservice.getItem('usernumber')
      }
      this.candidateservice.showallcontactdetails(data).subscribe((res: any) => {
        if (res.status == 'failure' && res.message == 'insufficient credits') {
          this.modalService.open(this.noCreditsCE, { windowClass: "myCustomModalClass", centered: true });
          //- Clevertap Contact Enrich credits exhausted event
          this.sendmailexpiry('Basic Contact Enrichment credits')
        }
        this.getCandidateDetails()

        //- Clevertap Premium Enrich event
        let ctObj = {
          "Name": this.basicdetails.firstname + " " + this.basicdetails.lastname,
          "Job title": this.basicdetails.jobtitle,
          "Company Name": this.basicdetails.companyname,
          "Source": this.basicdetails.source,
          "Location": this.basicdetails.locationname,
          "Origin": "Web app",
          "Profile URL": this.basicdetails.profileurl
        }
        this.cleverTapEvent("Contact_Enrich", ctObj);
      })
    }
  }

  showcontactdetails() {
    let ctObj = {}
    if (this.subscriptiondetails.balancecontactenrichmentcredits > 0) {
      ctObj = {
        "Name": this.basicdetails.firstname + " " + this.basicdetails.lastname,
        "Job title": this.basicdetails.jobtitle,
        "Company Name": this.basicdetails.companyname,
        "Source": this.basicdetails.source,
        "Location": this.basicdetails.locationname,
        "Origin": "Web app",
        "Profile URL": this.basicdetails.profileurl
      }
      if (this._localstorageservice.getItem('cecredits') > 0) {
        let data = {
          candidatenumber: this.candidateid,
          existingemailsarray: this.emailsdetails ? this.emailsdetails.map(x => x.contactdetail) : [],
          existingsocialprofilesarray: this.socialprofiles ? this.socialprofiles.map(x => x.link) : [],
          existingcontactnumbersarray: this.contactnumbers ? this.contactnumbers.map(x => x.contactdetail) : []
        }

        this.candidateservice.premiumcontactenrichment(data).subscribe((res: any) => {
          if (res.status == 'success' && res.message == 'enrichment details available') {
            // this.getCandidateDetails();
            this.fetchcredits()
            this.candidateservice.createCandidateData();

            //- Clevertap Premium Enrich event

            this.cleverTapEvent("Premium_Enrich", ctObj);
          } else if (res.message == 'no enrichment details') {
            this.cleverTapEvent("ContactNotFound_Premium", ctObj);
            this.premium_found = false
          } else if (res.status == 'failure' && res.message == 'insufficient credits') {
            this.modalService.open(this.noCreditsCE, { windowClass: "myCustomModalClass", centered: true });
            this.sendmailexpiry('Contact Enrichment credits')
          }
          this.getCandidateDetails()
        })
      } else {
        this.modalService.open(this.noCreditsCE, { windowClass: "myCustomModalClass", centered: true });
        this.sendmailexpiry('Contact Enrichment credits')
      }
    } else {
      let ctObj = {
        "Name": this.basicdetails.firstname + " " + this.basicdetails.lastname,
        "Job title": this.basicdetails.jobtitle,
        "Company Name": this.basicdetails.companyname,
        "Source": this.basicdetails.source,
        "Origin": "Web app",
        "Profile URL": this.basicdetails.profileurl
      }
      setTimeout(() => this.cleverTapEvent("PremiumEnrich_CreditExpiry", ctObj), 1000);

      this.router.navigateByUrl('/subscription/pricing')
    }

  }

  getCandidateDetails() {
    this.showProfileLoader = true;
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'none'
    this.candidateservice.getCandidateDetails(this.candidateid).subscribe((res: any) => {
      if (res.status == 'success') {
        let response = res.data.candidatedetails
        this.candidateData = response;
        this.allcandidatedetails = response
        this.basicdetails = response.basicdetails[0];
        this.additionaldetails = response.additionaldetails;
        this.educationdetails = response.educationdetails;
        this.certificationDetails = response.certificationdetails
        this.interestDetails = response.interests || [];
        var contactDetails = response.contactdetails;
        this.checkCadidateExistInAegis(response);
        this.contactdetail = contactDetails
        this.showProfileLoader = false
        if (this.contactdetail.socialprofiles) {
          if (this.contactdetail.socialprofiles.existingDetails.length > 0) {
            this.linkedin_url = this.contactdetail.socialprofiles.existingDetails.filter(x => x.platformname == 'linkedin')[0]
            this.facebook_url = this.contactdetail.socialprofiles.existingDetails.filter(x => x.platformname == 'facebook')[0]
            this.twitter_url = this.contactdetail.socialprofiles.existingDetails.filter(x => x.platformname == 'twitter')[0]
            this.github_url = this.contactdetail.socialprofiles.existingDetails.filter(x => x.platformname == 'github')[0]
          }
          if (this.contactdetail.socialprofiles.moreAvailableDetails.length > 0) {
            this.linkedin_url = this.linkedin_url ? this.linkedin_url: this.contactdetail.socialprofiles.moreAvailableDetails.filter(x => x.platformname == 'linkedin')[0]
            this.facebook_url = this.facebook_url ? this.facebook_url: this.contactdetail.socialprofiles.moreAvailableDetails.filter(x => x.platformname == 'facebook')[0]
            this.twitter_url = this.twitter_url? this.twitter_url: this.contactdetail.socialprofiles.moreAvailableDetails.filter(x => x.platformname == 'twitter')[0]
            this.github_url = this.github_url ? this.github_url: this.contactdetail.socialprofiles.moreAvailableDetails.filter(x => x.platformname == 'github')[0]

          }
        }
        let moreSocialProfilesCount = (contactDetails.socialprofiles) ? (contactDetails.socialprofiles.numberOfMoreAvailableDetails) : 0;
        let moreEmailsCount = (contactDetails.emails) ? (contactDetails.emails.numberOfMoreAvailableDetails) : 0;
        let moreContactNumbersCount = (contactDetails.contactnumbers) ? (contactDetails.contactnumbers.numberOfMoreAvailableDetails) : 0;
        let SocialProfilesCount = (contactDetails.socialprofiles) ? (contactDetails.socialprofiles.existingDetails.length) : 0;
        let EmailsCount = (contactDetails.emails) ? (contactDetails.emails.existingDetails.length) : 0;
        let ContactNumbersCount = (contactDetails.contactnumbers) ? (contactDetails.contactnumbers.existingDetails.length) : 0;
        this.existingContactDetails = SocialProfilesCount + EmailsCount + ContactNumbersCount
        this.totalcontacts_from_pdl = moreEmailsCount + moreContactNumbersCount
        if (this.totalcontacts_from_pdl == 0) {
          let ctObj = {
            "Name": this.basicdetails.firstname + " " + this.basicdetails.lastname,
            "Job title": this.basicdetails.jobtitle,
            "Company Name": this.basicdetails.companyname,
            "Source": this.basicdetails.source,
            "Origin": "Web app",
            "Location": this.basicdetails.profileurl,
            "Profile URL": this.basicdetails.profileurl
          }
          this.cleverTapEvent("ContactNotFound_Basic", ctObj);
        }
        var moreemails = []
        var morecontacts = []
        if (contactDetails.emails && contactDetails.emails.newMoreAvailableDetails) {
          contactDetails.emails.newMoreAvailableDetails.forEach((x, index) => {
            moreemails.push({
              "contactdetail": x.contactdetail,
              "contactdetailcategory": x.contactdetailcategory,
              "emailverificationstatus": x.emailverificationstatus,
              "type": x.type,
              "candidatecontactdetailid": 'contactDetails' + index
            })
          })
        }
        if (contactDetails.contactnumbers && contactDetails.contactnumbers.newMoreAvailableDetails) {
          contactDetails.contactnumbers.newMoreAvailableDetails.forEach((x, index) => {
            morecontacts.push({
              "contactdetail": x.contactdetail,
              "contactdetailcategory": x.contactdetailcategory,
              "emailverificationstatus": x.emailverificationstatus,
              "type": x.type,
              "candidatecontactdetailid": 'contactnumber' + index
            })
          })
        }
        this.moreAvailableContactDetails = {
          socialprofiles: contactDetails.socialprofiles ? contactDetails.socialprofiles.moreAvailableDetails : [],
          emails: moreemails,
          contactnumbers: morecontacts
        }

        // this.getAllContactDetails()
        // this.getpremiumenrichmentstatus()
        this.gettags()
        // this.educationdetails.map(x => {
        //   x.enddate = moment(x.enddate).format('YYYY'),
        //     x.startdate = moment(x.startdate).format('YYYY')
        //   return x
        // })
        this.experiencedetails = response.experiencedetails || [];
         const logoData = this.experiencedetails.map(item=>{
          if(item?.id || item?.companyname){
            return {
              ...(item?.id && {id: item.id}),
              ...(item?.companyname && {name: item.companyname}),
            }
          }
         }).filter(Boolean);

          logoData?.length && this.personSearchService.getCompanyLogoV2(logoData).subscribe((res: any) => {
            if(res && res.status == "success"){
              const resultName = res.data
              resultName.forEach(obj => {
                const matchingObj = this.experiencedetails.filter((item) =>
                {
                  if(obj.searchedVia === 'id'){
                    return item?.id === obj.key;
                  } else if(obj.searchedVia === 'name')
                    return item?.companyname === obj.key;
                });

                if (matchingObj && matchingObj.length) {
                  let companyLogo = obj.companylogo
                  matchingObj.forEach(x => {
                    x.companylogo = companyLogo;
                  })
                }
              });

          }
          this.experiencedetails.map(x => {
            if (x.enddate == 'Present') {
              x.iscurrent = 1
            }
            // x.enddate = moment(x.enddate).format('YYYY'),
            //   x.startdate = moment(x.startdate).format('YYYY')
            return x
          })
        });
        if (this.additionaldetails.length > 0) {
          this.skillsdata = this.additionaldetails.filter(x=>x.type == 'skills');
          this.skillsdata = _.pluck(this.skillsdata, 'information')
        //  this.SkillsOldOBj = this.additionaldetails.information
        }
        else {
          this.skillsdata = []
        }

        this.isProfileTabCalled = true;

        this.candidateContactObj['idinindex'] = this.basicdetails?.elastic_id;
        this.candidateContactObj['elasticid'] = this.basicdetails?.elastic_id;
        this.candidateContactObj['contactDetails'] = this.contactdetail?.emails;
        this.candidateContactObj['candidatenumber'] = res?.data?.candidatenumber;
        this.candidateContactObj['first_name'] = this.basicdetails?.firstname;
        this.candidateContactObj['last_name'] = this.basicdetails?.lastname;
        this.candidateContactObj['id'] = this.basicdetails?.elastic_id;
        this.candidateContactObj['iswebbtreeverified'] = this.basicdetails?.iswebbtreeverified;
        this.candidateContactObj['usedWebbtreeIntroduction'] = this.basicdetails?.usedWebbtreeIntroduction;
        this.candidateContactObj['revealContactAttempted'] = this.basicdetails?.revealContactAttempted;
        this.candidateContactObj['isRevealRetryAvailable'] = this.basicdetails?.isRevealRetryAvailable || false;
        this.candidateContactObj['profileurl'] = this.basicdetails?.profileurl;
        let tempArr = [];
        if(this.contactdetail?.emails?.existingDetails){
          tempArr = tempArr.concat(this.contactdetail.emails.existingDetails);
        }
        if(this.contactdetail?.contactnumbers?.existingDetails){
          tempArr = tempArr.concat(this.contactdetail?.contactnumbers?.existingDetails);
        }
        this.candidateContactObj['existingContactDetails'] = tempArr;
        this.callContactSlider = true;
      }
      this.reverseComponentSubject.next(this.allcandidatedetails);
    }, () => {
      this.showProfileLoader = false;
    })
    if(this.tabtoShow == 'notes') {
      if (this.notesslider) {
        let el: HTMLElement = this.notesslider.nativeElement;
        el.click();
      }
    }
  }

  /**
   * Fuction will call when person-search-contact tab emit an event on contact reveal/ add-contact-manual
   * @param event data sent in case of reveal contact and null value in case of add-manual-contact
   */
  eventHandler(event){

    if(event){
      const obj = {
        work_email:[],
        personal_email: [],
        mobile_phone:[]
      }
      const existingContactDetails = event?.data?.existingContactDetails;
      if(existingContactDetails){
        existingContactDetails.forEach(x=>{
          if(x.type === 'contactnumber') obj.mobile_phone.push(x.contactdetail);
          else if(x.type === 'email'){
            if(x.contactdetailcategory === 'personal'){
              obj.personal_email.push(x.contactdetail);
            }
            else if(x.contactdetailcategory === 'professional'){
              obj.work_email.push(x.contactdetail);
            }
          }
        })
      }
      obj['candidatenumber'] = event?.data?.candidatenumber;
    }
    this.refreshCandidateListEvent.emit("refresh")
  }

  getpremiumenrichmentstatus() {
    let data = {
      candidatenumber: this.candidateid
    }
    this.candidateservice.fetchpremiumenrichmentstatus(data).subscribe((res: any) => {
      if (res.status == 'success') {
        this.premiumenrichmentstatus = res.data
      }
    })
  }

  SocialLinkFilters(sociallink) {

    this.linkedin = sociallink.filter((x) => {
      return x.platformname == 'linkedin'
    });

    this.facebook = sociallink.filter((x) => {
      return x.platformname == 'facebook'
    });

    this.angel = sociallink.filter((x) => {
      return x.platformname == 'angel' || x.platformname == 'angellist'
    });

    this.behance = sociallink.filter((x) => {
      return x.platformname == 'behance'
    });

    this.twitter = sociallink.filter((x) => {
      return x.platformname == 'twitter'
    });

    this.github = sociallink.filter((x) => {
      return x.platformname == 'github'
    });

    this.reddit = sociallink.filter((x) => {
      return x.platformname == 'reddit'
    });

    this.instagram = sociallink.filter((x) => {
      return x.platformname == 'instagram'
    });

    this.website = sociallink.filter((x) => {
      return x.platformname == 'website'
    });


    this.quora = sociallink.filter((x) => {
      return x.platformname == 'quora'
    });

    this.aboutme = sociallink.filter((x) => {
      return x.platformname == 'aboutme'
    });

    this.google = sociallink.filter((x) => {
      return x.platformname == 'google'
    });

    this.youtube = sociallink.filter((x) => {
      return x.platformname == 'youtube'
    });

    this.flickr = sociallink.filter((x) => {
      return x.platformname == 'flickr'
    });

    this.pinterest = sociallink.filter((x) => {
      return x.platformname == 'pinterest'
    });

    this.stackoverflow = sociallink.filter((x) => {
      return (x.platformname == 'stack overflow' || x.platformname == 'stackoverflow')
    });

    this.foursquare = sociallink.filter((x) => {
      return x.platformname == 'foursquare'
    });

    this.dribbble = sociallink.filter((x) => {
      return x.platformname == 'dribbble'
    });

    this.gravatar = sociallink.filter((x) => {
      return x.platformname == 'gravatar'
    });

    this.other = sociallink.filter((x) => {
      return x.platformname != 'linkedin' && x.platformname != 'facebook' && x.platformname != 'angel' && x.platformname != 'angellist'
        && x.platformname != 'behance' && x.platformname != 'website' && x.platformname != 'twitter' && x.platformname != 'github'
        && x.platformname != 'instagram' && x.platformname != 'aboutme' && x.platformname != 'google' && x.platformname != 'quora'
        && x.platformname != 'youtube' && x.platformname != 'flickr' && x.platformname != 'foursquare' && x.platformname != 'gravatar' && x.platformname != 'pinterest'
        && x.platformname != 'reddit' && x.platformname != 'stack overflow' && x.platformname != 'stackoverflow' && x.platformname != 'dribbble'
    });

  }


  dismissCandidateSlider() {
    document.getElementById("mySidebar2").style.display = "none";
    document.getElementById("myOverlay2").style.display = "none";
    document.getElementById('dropdowndata').style.display = 'none'

    if (this.detailsslider) {
      let el: HTMLElement = this.detailsslider.nativeElement;
      el.click();
    }
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'block';

  }

  showAllDetail(type) {
    this.tabtoShow = type
    this.showAllDetails = true;
    this.showExperienceDetails = false;
    this.showAdditionalDetails = false;
    this.showEducationDetails = false;
    this.showBasicDetails = false;
    this.showEditContacts = false;
    this.iscurrent = 0
    this.skillerror = false;
    this.joblist = [];
    this.companylist = [];
    this.locationlist = [];
    this.degreelist = [];
    this.schoollist = [];
    this.viewmorenumber = false
    this.viewmoreEmails = false
    this.isPreviewApiCalled = false;
    this.isProfileTabCalled = false;
    this.candidateContactObj = {};
    this.callContactSlider = false;
    this.getCandidateDetails()

    // this.fetchcredits()
    // if (type == 'details') {
    //   if (this.detailsslider) {
    //     let el: HTMLElement = this.detailsslider.nativeElement;
    //     el.click();
    //   }
    // }
    // if (type == 'contact') {
    //   if (this.contactslider) {
    //     let el: HTMLElement = this.contactslider.nativeElement;
    //     el.click();
    //     this.seemorecontacts('viewmoreLinks')
    //   }
    // }
  }


  //Edit Experience Div
  EditExperienceDetails(experience) {
    this.experienceOldOBj = experience
    this.experienceid = experience ? experience.candidateexperienceid : null
    const modalRef =  this.modalService.open(AddEditExperienceModalComponent, { size: 'lg' as 'lg', centered: true, backdrop: 'static', keyboard: false })
    modalRef.componentInstance.experienceDetails = experience ? experience : null;
    modalRef.componentInstance.candidateid = this.candidateid ? this.candidateid : null;
    modalRef.componentInstance.experienceid = this.experienceid ? this.experienceid : null;
    modalRef.componentInstance.basicdetails = this.basicdetails;

    modalRef.componentInstance.passEntry.subscribe((x) => {
      this.modalService.dismissAll()
      if (x == 'success') {
        if(experience && experience.candidateexperienceid){
        this.toastmessage('Experience Updated Succesfully', 'success')
        }else{
        this.toastmessage('Experience Added Succesfully', 'success')
        }
        this.getCandidateDetails()
      }
      else if (x == 'error') {
        this.toastmessage('Something went Wrong', 'error')
      }
      this.refreshCandidateListEvent.emit("refresh");
    })
  }


  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  openDeleteExperienceModal(experience) {
    this.deleteExperienceID = experience.candidateexperienceid;
    const confirmRef = this.modalService.open(this.deleteexperience, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }


  //Remove Experience Details
  DeleteExperienceDetails() {
    let data = {
      candidateexperienceid: this.deleteExperienceID,
      candidatenumber: this.candidateid,
      usernumber: this._localstorageservice.getItem('usernumber')
    }
    this.candidateservice.removeCandidateExperience(data).subscribe((res: any) => {
      if (res.status == 'success') {
        this.toastmessage('Experience Deleted Successfully', 'success')
        this.modalService.dismissAll();
        this.candidateservice.createCandidateData();
        this.getCandidateDetails();
        //- Clevertap Edit Profile event
        let ctObj = {
          "Name": this.basicdetails.firstname + " " + this.basicdetails.lastname,
          "Job title": this.basicdetails.jobtitle,
          "Company Name": this.basicdetails.companyname,
          "Source": this.basicdetails.source,
          "Location": this.basicdetails.locationname,
          "Origin": "Web app"
        }
        this.cleverTapEvent("Edit Profile", ctObj);
      } else {
        this.toastmessage('Something Went Wrong', 'success')

      }
      this.refreshCandidateListEvent.emit("refresh");
    })
  }




  //Edit Education Div
  EditEducationDetails(education) {
    this.educationOldOBj = education
    this.educationid = education ? education.candidateeducationid : null

    const modalRef =  this.modalService.open(EducationModalComponent, { size: 'lg' as 'lg', centered: true, backdrop: 'static', keyboard: false })
    modalRef.componentInstance.educationdetails = education ? education : null
    modalRef.componentInstance.candidateid = this.candidateid ? this.candidateid : null
    modalRef.componentInstance.educationid = this.educationid ? this.educationid : null

    modalRef.componentInstance.passEntry.subscribe((x) => {
      this.modalService.dismissAll()
      if (x == 'success') {
         if(education && education.candidateeducationid){
        this.toastmessage('Education Updated Successfully', 'success')
        }else{
          this.toastmessage('Education Added Successfully', 'success')
        }
        this.getCandidateDetails()
      }
      else if (x == 'error') {
        this.toastmessage('Something went Wrong', 'error')
      }
      this.refreshCandidateListEvent.emit("refresh")
    })
  }

  //Add Education Details
  addeducation() {
    let data = {}
    if (this.education_form.valid) {
      data = {
        candidateeducationid: this.educationid ? this.educationid : null,
        candidatenumber: this.candidateid,
        degree: this.education_form.value.degree,
        institutename: this.education_form.value.schoolname,
        fieldofstudy: this.education_form.value.fieldstudyname,
        startdate: moment(this.education_form.value.startyear).format('YYYY-MM-DD'),
        enddate: moment(this.education_form.value.endyear).format('YYYY-MM-DD'),
        usernumber: this._localstorageservice.getItem('usernumber')
      }

      if (!this.educationid) {
        data['activitylog'] = [{
          "action": "'create'",
          "tablename": "'candidateeducation'",
          "type": "'education'",
          "updatedfieldname": "'null'",
          "oldvalue": "'null'",
          "newvalue": "'null'"
        }]
      } else if (this.educationid) {
        if ('startdate' in this.educationOldOBj) {
          this.educationOldOBj['startdate'] = moment(this.educationOldOBj.startdate).format('YYYY-MM-DD')
        } if ('enddate' in this.educationOldOBj) {
          this.educationOldOBj['enddate'] = moment(this.educationOldOBj.enddate).format('YYYY-MM-DD')
        }
        let activity = [];
        let educationOldObj = {
          degree: this.educationOldOBj.degree,
          institutename: this.educationOldOBj.institutename,
          fieldofstudy: this.educationOldOBj.fieldofstudy,
          startdate: this.educationOldOBj.startdate,
          enddate: this.educationOldOBj.enddate,
        }
        let result = Object.keys(educationOldObj).filter(k => educationOldObj[k] !== data[k]);
        result.map((elem, index) => {
          activity.push({
            action: "'update'",
            tablename: "'candidateeducation'",
            type: "'education'",
            updatedfieldname: "'" + elem + "'",
            oldvalue: educationOldObj[elem] ? "'" + educationOldObj[elem].replace(/'/g, '') + "'" : "'null'",
            newvalue: data[elem] ? "'" + data[elem].replace(/'/g, '') + "'" : "'null'",
          })
        })
        if (activity.length > 0) {
          data['activitylog'] = activity
        }
      }

      this.candidateservice.updateCandidateEducation(data).subscribe((res: any) => {
        if (res.status == 'success') {
          this.toastmessage('Education Added Successfully', 'success')
          this.candidateservice.createCandidateData();
          this.showAllDetail('details')

          //- Clevertap Edit Profile event
          let ctObj = {
            "Name": this.basicdetails.firstname + " " + this.basicdetails.lastname,
            "Job title": this.basicdetails.jobtitle,
            "Company Name": this.basicdetails.companyname,
            "Source": this.basicdetails.source,
            "Location": this.basicdetails.locationname,
            "Origin": "Web app"
          }
          this.cleverTapEvent("Edit Profile", ctObj);
        } else {
          this.toastmessage('Something Went Wrong', 'success')

        }
      })
    } else {
      this.validateAllFormFields(this.education_form);
    }

  }

  openDeleteEducationModal(education) {
    this.deleteEducationID = education.candidateeducationid;
    const confirmRef = this.modalService.open(this.deleteeducation, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  //Remove Education Details
  DeletedEducationDetails() {
    let data = {
      candidateeducationid: this.deleteEducationID,
      candidatenumber: this.candidateid,
      usernumber: this._localstorageservice.getItem('usernumber')
    }
    this.candidateservice.removeCandidateEducation(data).subscribe((res: any) => {
      if (res.status == 'success') {
        this.toastmessage('Education Deleted Successfully', 'success')
        this.modalService.dismissAll();
        this.getCandidateDetails();
        //- Clevertap Edit Profile event
        let ctObj = {
          "Name": this.basicdetails.firstname + " " + this.basicdetails.lastname,
          "Job title": this.basicdetails.jobtitle,
          "Company Name": this.basicdetails.companyname,
          "Source": this.basicdetails.source,
          "Location": this.basicdetails.locationname,
          "Origin": "Web app"
        }
        this.cleverTapEvent("Edit Profile", ctObj);
      } else {
        this.toastmessage('Something Went Wrong', 'success')

      }
      this.refreshCandidateListEvent.emit("refresh");
    })

  }

  EditBasicDetails() {
    this.showAllDetails = false;
    this.showExperienceDetails = false
    this.showAdditionalDetails = false
    this.showEducationDetails = false
    this.showBasicDetails = true;
    this.showEditContacts = false;

    this.candidate_form = this.fb.group({
      firstName: [this.basicdetails.firstname, Validators.compose([Validators.required, Validators.pattern(/^(?!.*<[^>]+>).*/i)])],
      lastName: [this.basicdetails.lastname, Validators.compose([Validators.required, Validators.pattern(/^(?!.*<[^>]+>).*/i)])],
      companyName: [this.basicdetails.companyname, Validators.compose([Validators.required, Validators.pattern(/^(?!.*<[^>]+>).*/i)])],
      jobName: [this.basicdetails.jobtitle, Validators.compose([Validators.required, Validators.pattern(/^(?!.*<[^>]+>).*/i)])],
      worklocation: [this.basicdetails.locationname, Validators.compose([Validators.required, Validators.pattern(/^(?!.*<[^>]+>).*/i)])],
      publicProfileLink: [this.basicdetails.profileurl, [Validators.required, Validators.pattern('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?')]],
    })
  }


  updateBasicDetails() {
    let candidateOldObj = {
      firstname: this.basicdetails.firstname,
      lastname: this.basicdetails.lastname,
      companyname: this.basicdetails.companyname,
      jobtitle: this.basicdetails.jobtitle,
      locationname: this.basicdetails.locationname,
      profileurl: this.basicdetails.profileurl
    }
    if (this.candidate_form.valid) {
      let data = {
        candidatenumber: this.candidateid,
        firstname: this.candidate_form.value.firstName,
        lastname: this.candidate_form.value.lastName,
        companyname: this.candidate_form.value.companyName,
        jobtitle: this.candidate_form.value.jobName,
        locationname: this.candidate_form.value.worklocation,
        profileurl: this.candidate_form.value.publicProfileLink,
        usernumber: this._localstorageservice.getItem('usernumber')
      }

      let activity = [];
      let result = Object.keys(candidateOldObj).filter(k => candidateOldObj[k] !== data[k]);
      result.map((elem, index) => {
        activity.push({
          action: "'update'",
          tablename: "'candidate'",
          type: "'basic details'",
          updatedfieldname: "'" + elem + "'",
          oldvalue: candidateOldObj[elem] ? "'" + candidateOldObj[elem].replace(/'/g, '') + "'" : "'null'",
          newvalue: data[elem] ? "'" + data[elem].replace(/'/g, '') + "'" : "'null'"
        })
      })
      if (activity.length > 0) {
        data['activitylog'] = activity
      }
      this.candidateservice.updateCandidateDetails(data).subscribe((res: any) => {
        if (res.status == 'success') {
          this.toastmessage('Basic Details Updated Successfully', 'success')
          this.showAllDetail('details')
          this.candidateservice.createCandidateData();

          //- Clevertap Edit Profile event
          let ctObj = {
            "Name": this.basicdetails.firstname + " " + this.basicdetails.lastname,
            "Job title": this.basicdetails.jobtitle,
            "Company Name": this.basicdetails.companyname,
            "Source": this.basicdetails.source,
            "Location": this.basicdetails.locationname,
            "Origin": "Web app"
          }
          this.cleverTapEvent("Edit Profile", ctObj);
        } else {
          this.toastmessage('Something Went Wrong', 'success')

        }
      })
    } else {
      this.validateAllFormFields(this.candidate_form)
    }
  }


  //Edit Additional Details Div
  EditAdditionalDetails() {
    this.showAllDetails = false;
    this.showExperienceDetails = false
    this.showAdditionalDetails = true
    this.showEducationDetails = false
    this.showBasicDetails = false;
    this.showEditContacts = false;
  }




  AddSkills(skill?: string) {
    if (this.skills != undefined && this.skills.length != '') {
      this.skillsdata.push(this.skills)
      this.skills = ''
      this.skillerror = false
    }
  }

  removeskills(i) {
    this.skillsdata.splice(i, 1);
  }

  searchSkills() {
    if (this.skills != '' && this.skills.length > 2) {
      this.getautocompleteData('skills', this.skills).subscribe((res) => {
        this.skillsList = res
      })
    }
  }


  //Add Additional Details
  addAdditionDetails() {
    let skillsid = this.additionaldetails ? this.additionaldetails.candidateadditionalinformationid : null
    if (this.skillsdata.length > 0) {
      let data = {
        candidateadditionalinformationid: skillsid,
        candidatenumber: this.candidateid,
        skills: this.skillsdata,
        usernumber: this._localstorageservice.getItem('usernumber')
      }
      if (!skillsid) {
        data['activitylog'] = [{
          "action": "'create'",
          "tablename": "'candidateadditionalinformation'",
          "type": "'skills'",
          "updatedfieldname": "'null'",
          "oldvalue": "'null'",
          "newvalue": "'null'"
        }]
      } else if (skillsid && this.SkillsOldOBj != this.skillsdata) {
        data['activitylog'] = [{
          "action": "'update'",
          "tablename": "'candidateadditionalinformation'",
          "type": "'skills'",
          "updatedfieldname": "'skills'",
          "oldvalue": "'" + this.SkillsOldOBj.trim().replace(/'/g, '') + "'",
          "newvalue": "'" + this.skillsdata.join(", ").trim().replace(/'/g, '') + "'"
        }]
      }
      this.candidateservice.updateCandidateAdditional(data).subscribe((res: any) => {
        if (res.status == 'success') {
          this.toastmessage('Skills Added Successfully', 'success')
          this.candidateservice.createCandidateData();
          this.showAllDetail('details')

          //- Clevertap Edit Profile event
          let ctObj = {
            "Name": this.basicdetails.firstname + " " + this.basicdetails.lastname,
            "Job title": this.basicdetails.jobtitle,
            "Company Name": this.basicdetails.companyname,
            "Source": this.basicdetails.source,
            "Location": this.basicdetails.locationname,
            "Origin": "Web app"
          }
          this.cleverTapEvent("Edit Profile", ctObj);
        } else {
          this.toastmessage('Something Went Wrong', 'error')
        }
      })

    }
    else {
      this.skillerror = true
    }
  }

  openAddNOtesModal() {
    const modalRef = this.modalService.open(CandidateNoteComponent, { size: 'xs' as 'lg', centered: true });
    modalRef.componentInstance.noteforCandidate = this.basicdetails
    modalRef.componentInstance.passEntry.subscribe((x) => {
      if (x == 'noteAdded') {
        this.toastmessage('Notes Added for Selected Candidate Succesfully', 'success')
      } else if (x == 'error') {
        this.toastmessage('Something went Wrong', 'error')
      }
    })
  }

  OpenCallLogModal() {
    const modalRef = this.modalService.open(CallLogComponent, { size: 'xs' as 'lg', centered: true });
    modalRef.componentInstance.calllogforCandidate = this.basicdetails
    modalRef.componentInstance.passEntry.subscribe((x) => {
      if (x == 'calllogAdded') {
        this.toastmessage('CAll Log Added for Selected Candidate Succesfully', 'success')
      } else if (x == 'error') {
        this.toastmessage('Something went Wrong', 'error')
      }
    })
  }


  OpenSendEmailModule(preSelectEmail: string = null) {
    if (this._localstorageservice.getItem('secredits') > 0) {
      const modalRef = this.modalService.open(CandidateEmailComponent, { size: 'lg' as 'lg', centered: true });
      modalRef.componentInstance.emailforCandidate = this.allcandidatedetails ? this.allcandidatedetails : null
      modalRef.componentInstance.preSelectEmail = preSelectEmail
      modalRef.componentInstance.candidatenumber = this.candidateid,
        modalRef.componentInstance.pipelinestatus = this.basicdetails.pipelinestatus,
        modalRef.componentInstance.passEntry.subscribe((x) => {
          if (x == 'emailsend') {
            this.toastmessage('Email Send Successfully', 'success')
            this.fetchcredits()
          } else if (x == 'nocredits') {
            this.modalService.open(this.noCreditsCE, { windowClass: "myCustomModalClass", centered: true });
            this.sendmailexpiry('Smart Email credits')
          } else if (x == 'limitexceeded') {
            this.toastmessage('mail limit exceeded', 'error')
          } else if (x == 'error') {
            this.toastmessage('Something went Wrong', 'error')
          }
        })
    } else {
      this.modalService.open(this.noCreditsCE, { windowClass: "myCustomModalClass", centered: true });
      this.sendmailexpiry('Smart Email credits')
    }
  }

  getActivityText(activity): string {
    let action;
    if (activity.oldvalue == "" || activity.oldvalue == "null") {
      activity.oldvalue = null
    }
    if (activity.newvalue === '' || activity.newvalue === null || activity.newvalue === '') {
      action = 'deleted';
    } else if (activity.oldvalue === '' || activity.oldvalue === null) {
      action = 'added';
    }
    if (activity.action === 'create' || activity.action === 'add') {
      action = 'created';
    } else if (activity.action === 'remove') {
      action = 'deleted';
    } else if (activity.action === 'update' || activity.action === 'updated') {
      action = 'updated';
    } else {
      action = activity.action;
    }
    ///For call Log and Notes
    if (action === 'updated' && activity.type === 'calllog') {
      let oldvalue = JSON.parse(activity.oldvalue.replaceAll('\n', ''))
      let newvalue = JSON.parse(activity.newvalue.replaceAll('\n', ''))
      if (oldvalue && newvalue) {
        return `Call Log are updated from (Outcome : ${oldvalue.Outcome} & Note : ${oldvalue.Note} ) to <br/>
        (Outcome : ${newvalue.Outcome} & Note : ${newvalue.Note} )`;
      }
    }
    else if (action === 'created' && activity.type === 'calllog') {
      try {
        let newvalue = JSON.parse(activity.newvalue)
        if (newvalue) {
          return `Outcome : ${newvalue.Outcome} & Note : ${newvalue.Note} `;
        }
      } catch {

      }
    }
    else if (action === 'updated' && activity.type === 'note') {
      return `Notes are updated from ${activity.oldvalue} to ${activity.newvalue}`;
    }
    else if (action === 'created' && activity.type === 'note') {
      return `${activity.newvalue}`;
    }
    ///For Experience
    else if (action === 'updated' && activity.type === 'experience' && activity.newvalue !== null) {
      if (activity.newvalue === 'null' && activity.updatedfieldname === 'enddate') {
        return `End Date has Removed`;
      } else if (activity.updatedfieldname === 'iscurrent') {
        return `Current Experience has Updated`;
      } else if (activity.newvalue !== 'null' && activity.updatedfieldname === 'enddate') {
        return `Experience End Date has been updated as ${moment(activity.newvalue).format('YYYY')}`;
      } else if (activity.updatedfieldname === 'iscurrent') {
        return `Current Experience has Updated`;
      } else if (activity.newvalue === '' && activity.updatedfieldname === 'workdescription') {
        return `Experience Work Description has been removed`;
      } else if (activity.oldvalue === 'null' && activity.updatedfieldname === 'workdescription') {
        return `Experience Work Description is updated to ${activity.newvalue}`;
      } else {
        return `Experience ${activity.updatedfieldname} is updated from ${activity.oldvalue} to ${activity.newvalue}`;
      }
    } else if (action === 'deleted' && activity.type === 'experience') {
      return `Experience has been removed`;
    }
    else if (action === 'created' && activity.type === 'experience') {
      return `Experience Added`;
    }
    //for Education
    else if (action === 'updated' && activity.type === 'education') {
      if (activity.updatedfieldname === 'enddate' || activity.updatedfieldname === 'startdate') {
        return `Education ${activity.updatedfieldname} has been updated from ${moment(activity.oldvalue).format('YYYY')} to ${moment(activity.newvalue).format('YYYY')}`;
      } else {
        return `Education ${activity.updatedfieldname} is updated from ${activity.oldvalue} to ${activity.newvalue}`;
      }
    }
    else if (action === 'deleted' && activity.type === 'education') {
      return `Education has been removed`;
    }
    else if (action === 'created' && activity.type === 'education') {
      return `Education Added`;
    }
    //for Basic Details
    else if (action == 'updated' && activity.type === 'basic details' && activity.oldvalue != null) {
      return `${activity.updatedfieldname} has been updated from ${activity.oldvalue} to ${activity.newvalue}`;
    }
    else if (action == 'updated' && activity.type === 'basic details' && activity.oldvalue == null) {
      return `${activity.updatedfieldname} has been updated to ${activity.newvalue}`;
    }
    //for Skills
    else if (action == 'updated' && activity.type === 'skills') {
      return `${activity.updatedfieldname} has been updated from ${activity.oldvalue} to ${activity.newvalue}`;
    } else if (action == 'created' && activity.type === 'skills') {
      return `Skills are Added`;
    }
    //for Grabbed
    else if (action == 'created' && (activity.type === 'grabbed' || activity.type == 'bulk grabbed')) {
      return `Candidate has been grabbed`;
    }
    else if (action == 'created' && activity.type === 'added') {
      return `Candidate has been Added`;
    }

    else if(action == 'created' && activity.type === 'Reveal Contact'){
      return activity.updatedfieldname;
    }

    // for tags
    else if (action === 'updated' && activity.type === 'tags') {
      return `Tags are updated from ${activity.oldvalue} to ${activity.newvalue}`;
    }
    else if (action === 'created' && activity.type === 'tags') {
      return `${activity.newvalue}`;
    }
    else if (action === 'deleted' && activity.type === 'tags') {
      return `Tag has been removed`;
    }

    //for TalentPipeline Status
    else if (action == 'updated' && (activity.type === 'pipeline status' || activity.type === 'cron - pipeline status')) {
      return `Pipeline Status was updated from ${activity.oldvalue} to ${activity.newvalue}`;
    }
    //for Contact Details
    else if (action == 'created' && activity.type === 'contact details - social profile') {
      return `New Social Profile Link was Added -  ${activity.newvalue}`;
    }
    else if (action == 'updated' && activity.type === 'contact details - social profile') {
      return `Social Profile Link was updated from ${activity.oldvalue} to ${activity.newvalue}`;
    }
    else if (action == 'deleted' && activity.type === 'contact details - social profile') {
      return `Social Profile Link was removed`;
    }
    else if (action == 'created' && activity.type === 'contact details - email') {
      return `New Email ID was Added -  ${activity.newvalue}`;
    }
    else if (action == 'updated' && activity.type === 'contact details - email') {
      return `Email ID was updated from ${activity.oldvalue} to ${activity.newvalue}`;
    }
    else if (action == 'deleted' && activity.type === 'contact details - email') {
      return `Email ID was removed`;
    }
    else if (action == 'created' && activity.type === 'contact details - contact number') {
      return `New Contact Number was Added -  ${activity.newvalue}`;
    }
    else if (action == 'updated' && activity.type === 'contact details - contact number') {
      return `Contact Number was updated from ${activity.oldvalue} to ${activity.newvalue}`;
    }
    else if (action == 'deleted' && activity.type === 'contact details - contact number') {
      return `Contact Number was removed`;
    }
    else if (activity.updatedfieldname == 'primaryemailid' || activity.updatedfieldname == 'primarycontactnumber') {
      return `Primary ${activity.type} has Added -  ${activity.newvalue}`;
    } else if (activity.action == 'pipl premium enrichment') {
      return 'Premium enrichment was done'
    } else if (activity.tablename) {
      if (activity.action == 'added') {
        return `Cv was added (${activity.oldvalue})`
      } else if (activity.action == 'removed') {
        return `Cv was removed (${activity.oldvalue})`
      }
    }
    if (activity.action == 'details updated') {
      return activity.oldvalue
    }
  }

  editNote(activity: any) {
    const dialogRef = this.modalService.open(CandidateNoteComponent, { size: 'lg' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    dialogRef.componentInstance.noteid = activity.primarykeyid;
    dialogRef.componentInstance.notesdata = activity.newvalue;
    dialogRef.componentInstance.oldnote = activity.newvalue;
    dialogRef.componentInstance.candidateNumber = this.candidateid
    dialogRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      if (receivedEntry == 'updated') {
        this.toastmessage('Notes Updated for Selected Candidate Succesfully', 'success')
      } else if (receivedEntry == 'error') {
        this.toastmessage('Something went Wrong', 'error')
      }
    })
  }

  editCalllog(candidate) {
    const dialogRef = this.modalService.open(CallLogComponent, { size: 'lg' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    let obj = {
      candidatenumber: this.candidateid,
      calllogid: candidate.primarykeyid ? candidate.primarykeyid : candidate.rawobject.id,
      oldvalue: candidate.oldvalue,
      "updatedfieldname": candidate.updatedfieldname,
      editFlag: true,
    }
    dialogRef.componentInstance.editCallLogData = obj;
    dialogRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      if (receivedEntry == 'updated') {
        this.toastmessage('CAll Log Updated for Selected Candidate Succesfully', 'success')
      } else if (receivedEntry == 'error') {
        this.toastmessage('Something went Wrong', 'error')
      }

    })
  }

  //Edit Contact Details Div
  EditContactDetails() {
    this.showAllDetails = false;
    this.showExperienceDetails = false
    this.showAdditionalDetails = false
    this.showEducationDetails = false
    this.showBasicDetails = false;
    this.showEditContacts = true;
    // this.getAllContactDetails()

  }

  getAllContactDetails() {
    let data = {
      "usernumber": this._localstorageservice.getItem('usernumber'),
      "candidatenumber": this.candidateid,
    }
    // const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    // loadn[0].style.display = 'none';
    this.candidateservice.getContactDetails(data).subscribe((res: any) => {
      if (res.status == 'success') {
        let response = res.data
        this.uniqueEnrichedvia = []
        this.getUniqueContactProviders(res.data)
          this.dataproviders =  this.removeKeysFromArrayObjects(this.allContactProviders, this.uniqueEnrichedvia);

        this.socialprofilesdata = response.socialprofiles
        this.emailsdata = response.emails && response.emails.length > 0 ? response.emails: !response.emails ? undefined: []
        this.personalemails = this.emailsdata == undefined ? undefined: this.emailsdata.filter(x=>x.contactdetailcategory == 'personal')
        this.professionalemails = this.emailsdata == undefined ? undefined: this.emailsdata.filter(x=>x.contactdetailcategory != 'personal')
        this.contactdata = response.contactnumbers && response.contactnumbers.length > 0 ? response.contactnumbers: !response.contactnumbers ? undefined: []


        if(this.personalemails && this.personalemails.length &&
          this.professionalemails && this.professionalemails.length &&
          this.contactdata && this.contactdata.length
          ){
          this.hideRevealContact = false
        }else{
          this.hideRevealContact = true
        }
        this.contactnumbers = response.contactnumbers && response.contactnumbers.length > 0 ? response.contactnumbers.map(x => {
          let res = x
          x.lastupdatedon = x.pipl_lastseen ? x.pipl_lastseen : x.pipl_validsince
          if (x.lastupdatedon) {
            let totalmonth = GlobalService.getDates(x.lastupdatedon).value
            if (totalmonth < 12) {
              x.lastupdatedon = totalmonth.toString() + ' mths'
            } else {
              let yearsandmonths = (totalmonth / 12).toString().split('.')
              let months = (totalmonth - (parseInt(yearsandmonths[0]) * 12)).toString()
              if (yearsandmonths.length > 1 && months != '0') {
                x.lastupdatedon = yearsandmonths[0] + ' yrs & ' + months + ' mths'
              } else {
                x.lastupdatedon = yearsandmonths[0] + ' yrs'
              }
            }
          }
          return res
        }) : []
        this.emailsdetails = response.emails && response.emails.length > 0 ? response.emails.map(x => {
          let res = x
          x.lastupdatedon = x.pipl_lastseen ? x.pipl_lastseen : x.pipl_validsince
          if (x.lastupdatedon) {
            let totalmonth = GlobalService.getDates(x.lastupdatedon).value
            if (totalmonth < 12) {
              x.lastupdatedon = totalmonth.toString() + 'mths'
            } else {
              let yearsandmonths = (totalmonth / 12).toString().split('.')
              let months = (totalmonth - (parseInt(yearsandmonths[0]) * 12)).toString()
              if (yearsandmonths.length > 1 && months != '0') {
                x.lastupdatedon = yearsandmonths[0] + ' yrs & ' + months + ' mths'
              } else {
                x.lastupdatedon = yearsandmonths[0] + ' yrs'
              }
            }
          }
          return res
        }) : []
        this.socialprofiles = response.socialprofiles
        this.socialprofiles = this.socialprofiles.concat(this.moreAvailableContactDetails.socialprofiles)
        this.contactnumbers = this.contactnumbers.concat(this.moreAvailableContactDetails.contactnumbers)
        this.emailsdetails = this.emailsdetails.concat(this.moreAvailableContactDetails.emails)
        if (this.socialprofiles) {
          this.socialprofiles = this.socialprofiles.map((x) => {
            let res = x
            if (!res.link.includes('http')) {
              res.link = 'https://' + res.link
            }
            return res
          })
          this.SocialLinkFilters(this.socialprofiles)
        }

        this.contact_form = this.fb.group({
          sociallinks: this.fb.array([]),
          contactemails: this.fb.array([]),
          phonenumber: this.fb.array([]),
        })

        const linkcontrol = <UntypedFormArray>this.contact_form.controls['sociallinks'];
        const contactcontrol = <UntypedFormArray>this.contact_form.controls['contactemails'];
        const phonecontrol = <UntypedFormArray>this.contact_form.controls['phonenumber'];

        if (this.socialprofilesdata.length > 0) {
          for (let iterator of this.socialprofilesdata) {
            linkcontrol.push(this.addsocialLinks(iterator));
          }
        } else {
          linkcontrol.push(this.addsocialLinks(null));
        }

        if (this.emailsdata.length > 0) {
          for (let iterator of this.emailsdata) {
            contactcontrol.push(this.addcontactemails(iterator));
          }
        } else {
          contactcontrol.push(this.addcontactemails(null));
        }

        if (this.contactdata.length > 0) {
          for (let iterator of this.contactdata) {
            phonecontrol.push(this.addcontactnumber(iterator));
          }
        } else {
          phonecontrol.push(this.addcontactnumber(null));
        }

        // setTimeout(()=>
        // loadn[0].style.display = 'block',1000);
      }
    })
  }

  addsocialLinks(olddata): UntypedFormGroup {
    return this.fb.group({
      link: [olddata ? olddata.link : null, [Validators.pattern('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w +\\.-]*/?'), RequiredValidator]],
      candidatesocialid: [olddata ? olddata.candidatesocialid : null],
      oldvalue: [olddata ? olddata.link : null],
      pdlenriched: [olddata ? olddata.pdlenriched : null]
    })


    function RequiredValidator(formControl: AbstractControl) {
      if (olddata && olddata.candidatesocialid) {
        return Validators.required(formControl);
      } else {
      }
      return null;
    }
  }

  addcontactemails(olddata): UntypedFormGroup {
    return this.fb.group({
      email: [olddata ? olddata.contactdetail : null, [Validators.pattern('^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$'), RequiredValidator]],
      candidatecontactdetailid: [olddata ? olddata.candidatecontactdetailid : null],
      oldvalue: [olddata ? olddata.contactdetail : null],
      pdlenriched: [olddata ? olddata.pdlenriched : null],
      isprimary: [olddata ? olddata.isprimary : 0]
    })

    function RequiredValidator(formControl: AbstractControl) {
      if (olddata && olddata.candidatecontactdetailid) {
        return Validators.required(formControl);
      } else {
      }
      return null;
    }
  }


  addcontactnumber(olddata): UntypedFormGroup {
    if (olddata && !olddata.countrycode && !olddata.contactdetail.includes('+')) {
      olddata.contactdetail = '+' + olddata.contactdetail
    }
    return this.fb.group({
      phone: [olddata ? olddata.contactdetail : null, RequiredValidator],
      candidatecontactdetailid: [olddata ? olddata.candidatecontactdetailid : null],
      oldvalue: [olddata ? olddata.contactdetail : null],
      pdlenriched: [olddata ? olddata.pdlenriched : null],
      isprimary: [olddata ? olddata.isprimary : 0]
    })

    function RequiredValidator(formControl: AbstractControl) {
      if (olddata && olddata.candidatecontactdetailid) {
        return Validators.required(formControl);
      } else {
      }
      return null;
    }
  }


  addSocialProfiles(type) {
    if (type == 'socialprofile') {
      let sociallength = this.contact_form.controls['sociallinks'].value.length
      if (this.contact_form.controls['sociallinks'].valid && this.contact_form.controls['sociallinks'].value[sociallength - 1].link) {
        const control = <UntypedFormArray>this.contact_form.controls['sociallinks'];
        control.push(this.addsocialLinks(null));
      }
    } else if (type == 'emails') {
      let emaillength = this.contact_form.controls['contactemails'].value.length
      if (this.contact_form.controls['contactemails'].valid && this.contact_form.controls['contactemails'].value[emaillength - 1].email) {
        const control = <UntypedFormArray>this.contact_form.controls['contactemails'];
        control.push(this.addcontactemails(null));
      }
    } else if (type == 'phone') {
      let phonelength = this.contact_form.controls['phonenumber'].value.length
      if (this.contact_form.controls['phonenumber'].valid && this.contact_form.controls['phonenumber'].value[phonelength - 1].phone) {
        const control = <UntypedFormArray>this.contact_form.controls['phonenumber'];
        control.push(this.addcontactnumber(null));
      }
    }

  }

  saveContactDetails() {
    if (this.contact_form.valid) {
      if (this.basicdetails.primaryemailid == null && this.contact_form.controls['contactemails'].value.length > 0) {
        let bydefaultprimaryemail = this.contact_form.controls['contactemails'].value[0]
        if (bydefaultprimaryemail.email) {
          this.MakeEmailPrimary(bydefaultprimaryemail.email, 0)
        }
      }

      if (this.basicdetails.primarycontactnumber == null && this.contact_form.controls['phonenumber'].value.length > 0) {
        let bydefaultprimarycontact = this.contact_form.controls['phonenumber'].value[0]
        if (bydefaultprimarycontact.phone) {
          this.MakeContactPrimary(bydefaultprimarycontact.phone, 0)
        }
      }

      let value = this.contact_form.getRawValue()
      let contactDetailsObj = {}    /// Main object to send to API Request
      value.sociallinks = value.sociallinks.filter((x) => { return x.link })   // For social Link - filtered null values
      value.contactemails = value.contactemails.filter((x) => { return x.email })       // For semail - filtered null values
      let phonevalues = []
      value.phonenumber.forEach((x) => {
        if (x.phone) {
          let phoneObj = {
            contactnumber: x.phone.internationalNumber.trim().toLowerCase(),
            countrycode: x.phone.dialCode,
            candidatecontactdetailid: x.candidatecontactdetailid,
            oldvalue: x.oldvalue,
            isprimary: x.isprimary
          }
          phonevalues.push(phoneObj)
        }
      })

      let socialprofiles = {};
      let socialprofileactivitylog = []
      let socialprofiledata = []
      for (let iterator of value.sociallinks) {
        if (iterator.candidatesocialid && iterator.oldvalue != iterator.link) {
          let activitylog = {
            action: "'update'",
            tablename: "'candidatesocial'",
            type: "'contact details - social profile'",
            updatedfieldname: "'link'",
            oldvalue: "'" + iterator.oldvalue + "'",
            newvalue: "'" + iterator.link + "'",
            candidatesocialid: "'" + iterator.candidatesocialid + "'"
          }
          socialprofileactivitylog.push(activitylog)

        } else if (!iterator.candidatesocialid) {
          let activitylog = {
            action: "'create'",
            tablename: "'candidatesocial'",
            type: "'contact details - social profile'",
            updatedfieldname: "'null'",
            oldvalue: "'null'",
            newvalue: "'" + iterator.link + "'",
          }
          socialprofileactivitylog.push(activitylog)
        }
      }

      if (socialprofileactivitylog.length > 0) {
        socialprofiles['data'] = value.sociallinks
        socialprofiles['activitylog'] = socialprofileactivitylog
      }

      let contactemail = {};
      let contactemailactivitylogs = []

      // this.backupcontactdetails = this.contactdata.filter((x)=>{ return x.isprimary == 1})[0]
      let backupprimaryemail = this.emailsdata.filter((x) => { return x.isprimary == 1 }).length > 0 ? this.emailsdata.filter((x) => { return x.isprimary == 1 })[0].contactdetail : 'null'
      let newprimaryemail = value.contactemails.filter((x) => { return x.isprimary == 1 }).length > 0 ? value.contactemails.filter((x) => { return x.isprimary == 1 })[0].email : 'null'
      if (backupprimaryemail != newprimaryemail) {
        let activitylog = {
          action: "'updateprimarycontact'",
          newvalue: `'${newprimaryemail}'`,
          oldvalue: `'${backupprimaryemail}'`,
          tablename: "'candidate'",
          type: "'email'",            // Can be 'email' or 'contactnumber'
          updatedfieldname: "'primarycontactnumber'"     // Can be 'primarycontactnumber' or 'primaryemailid'
        }
        contactemailactivitylogs.push(activitylog)
      }


      for (let iterator of value.contactemails) {
        if (iterator.candidatecontactdetailid && iterator.oldvalue != iterator.email) {
          let activitylog = {
            action: "'update'",
            tablename: "'candidatecontactdetail'",
            type: "'contact details - email'",
            updatedfieldname: "'contactdetail'",
            oldvalue: "'" + iterator.oldvalue + "'",
            newvalue: "'" + iterator.email + "'",
            candidatecontactdetailid: "'" + iterator.candidatecontactdetailid + "'"
          }
          contactemailactivitylogs.push(activitylog)

        } else if (!iterator.candidatecontactdetailid) {
          let activitylog = {
            action: "'create'",
            tablename: "'candidatecontactdetail'",
            type: "'contact details - email'",
            updatedfieldname: "'null'",
            oldvalue: "'null'",
            newvalue: "'" + iterator.email + "'",
          }
          contactemailactivitylogs.push(activitylog)
        }
      }

      if (contactemailactivitylogs.length > 0) {
        contactemail['data'] = value.contactemails
        contactemail['activitylog'] = contactemailactivitylogs
      }

      let contactnumber = {};
      let contactnumberactivityLog = []
      let backupcontactdetails = this.contactdata.filter((x) => { return x.isprimary == 1 }).length > 0 ? this.contactdata.filter((x) => { return x.isprimary == 1 })[0].contactdetail : 'null'
      let newprimarycontact = phonevalues.filter((x) => { return x.isprimary == 1 }).length > 0 ? phonevalues.filter((x) => { return x.isprimary == 1 })[0].contactnumber : 'null'

      if (backupcontactdetails != newprimarycontact) {
        let activitylog = {
          action: "'updateprimarycontact'",
          newvalue: `'${newprimarycontact}'`,
          oldvalue: `'${backupcontactdetails}'`,
          tablename: "'candidate'",
          type: "'contactnumber'",
          updatedfieldname: "'primaryemailid'"
        }
        contactnumberactivityLog.push(activitylog)
      }

      for (let iterator of phonevalues) {
        if (iterator.candidatecontactdetailid && iterator.oldvalue != iterator.contactnumber) {
          let activitylog = {
            action: "'update'",
            tablename: "'candidatecontactdetail'",
            type: "'contact details - contact number'",
            updatedfieldname: "'contactdetail'",
            oldvalue: "'" + iterator.oldvalue + "'",
            newvalue: "'" + iterator.contactnumber + "'",
            candidatecontactdetailid: "'" + iterator.candidatecontactdetailid + "'"
          }
          contactnumberactivityLog.push(activitylog)

        } else if (!iterator.candidatecontactdetailid) {
          let activitylog = {
            action: "'create'",
            tablename: "'candidatecontactdetail'",
            type: "'contact details - contact number'",
            updatedfieldname: "'null'",
            oldvalue: "'null'",
            newvalue: "'" + iterator.contactnumber + "'",
          }
          contactnumberactivityLog.push(activitylog)
        }
      }

      if (contactnumberactivityLog.length > 0) {
        contactnumber['data'] = phonevalues
        contactnumber['activitylog'] = contactnumberactivityLog
      }

      contactDetailsObj = {
        "usernumber": this._localstorageservice.getItem('usernumber'),
        "candidatenumber": this.candidateid,
        socialprofiles: socialprofiles,
        emails: contactemail,
        contactnumbers: contactnumber
      }

      this.candidateservice.updatecontactDetails(contactDetailsObj).subscribe((res: any) => {
        if (res.status == "success") {
          this.toastmessage('Contact Details Updated Successfully', 'success')
          this.showAllDetail('contact')
          this.candidateservice.createCandidateData();
        } else {
          this.toastmessage('Something Went Wrong', 'error')
        }
      })
    }
  }

  deleteSocialLink(links, i) {
    this.deleteSocialLinkID = links.candidatesocialid
    this.deleteSocialLinkindex = i
    if (this.deleteSocialLinkID) {
      const confirmRef = this.modalService.open(this.deletelink, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    } else {
      const control = <UntypedFormArray>this.contact_form.controls['sociallinks'];
      control.removeAt(i);
    }
  }

  deleteEmails(emails, i) {
    this.deleteEmaildID = emails.candidatecontactdetailid
    this.deleteEmailIndex = i
    if (this.deleteEmaildID) {
      const confirmRef = this.modalService.open(this.deletemail, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    } else {
      const control = <UntypedFormArray>this.contact_form.controls['contactemails'];
      control.removeAt(i);
    }
  }

  deleteContacts(contact, i) {
    this.deleteContactID = contact.candidatecontactdetailid
    this.deleteContactIndex = i
    if (this.deleteContactID) {
      const confirmRef = this.modalService.open(this.deletecontact, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    } else {
      const control = <UntypedFormArray>this.contact_form.controls['phonenumber'];
      control.removeAt(i);
    }
  }

  DeleteEmailID() {
    let data = {
      "usernumber": this._localstorageservice.getItem('usernumber'),
      "candidatenumber": this.candidateid,
      "type": "email",
      "detailid": this.deleteEmaildID
    }

    this.candidateservice.deleteContactDetails(data).subscribe((res: any) => {
      if (res.status == 'success') {
        this.toastmessage('Email Deleted Successfully', 'success')
        this.modalService.dismissAll();
        this.getCandidateDetails();
        const control = <UntypedFormArray>this.contact_form.controls['contactemails'];
        control.removeAt(this.deleteEmailIndex);
      } else {
        this.toastmessage('Something Went Wrong', 'error')
      }
    })
  }

  deleteContactNumber() {
    let data = {
      "usernumber": this._localstorageservice.getItem('usernumber'),
      "candidatenumber": this.candidateid,
      "type": "contact number",
      "detailid": this.deleteContactID
    }

    this.candidateservice.deleteContactDetails(data).subscribe((res: any) => {
      if (res.status == 'success') {
        this.toastmessage('Email Deleted Successfully', 'success')
        this.modalService.dismissAll();
        this.getCandidateDetails();
        const control = <UntypedFormArray>this.contact_form.controls['phonenumber'];
        control.removeAt(this.deleteContactIndex);
      } else {
        this.toastmessage('Something Went Wrong', 'error')
      }
    })
  }


  DeleteSocialProfileLink() {
    let data = {
      "usernumber": this._localstorageservice.getItem('usernumber'),
      "candidatenumber": this.candidateid,
      "type": "social profile",
      "detailid": this.deleteSocialLinkID
    }

    this.candidateservice.deleteContactDetails(data).subscribe((res: any) => {
      if (res.status == 'success') {
        this.toastmessage('Social Link Deleted Successfully', 'success')
        this.modalService.dismissAll();
        this.getCandidateDetails();
        const control = <UntypedFormArray>this.contact_form.controls['sociallinks'];
        control.removeAt(this.deleteSocialLinkindex);
      } else {
        this.toastmessage('Something Went Wrong', 'error')
      }
    })
  }

  MakeContactPrimary(contact, i) {
    if (contact.candidatecontactdetailid) {
      let data = {
        "candidatenumber": this.candidateid,
        "usernumber": this._localstorageservice.getItem('usernumber'),
        "type": "contactnumber",
        "candidatecontactdetailid": contact.candidatecontactdetailid,
        "oldcontactdetailvalue": "null",
        "newcontactdetailvalue": contact.phone.number.trim().toLowerCase(),
      }
      this.candidateservice.makeContactsPrimary(data).subscribe((res: any) => {
        if (res.status == 'success') {
          this.EditContactDetails()
        }
      })
    }
    else {
      const control = <UntypedFormArray>this.contact_form.controls['phonenumber'];
      for (let primaryindex = 0; primaryindex < control.length; primaryindex++) {
        control.at(primaryindex).patchValue({
          isprimary: 0
        })
      }

      control.at(i).patchValue({
        isprimary: 1
      })
    }
    this.basicdetails['primarycontactnumber'] = 'phone'
  }

  MakeEmailPrimary(email, i) {
    if (email.candidatecontactdetailid) {
      let data = {
        "candidatenumber": this.candidateid,
        "usernumber": this._localstorageservice.getItem('usernumber'),
        "type": "email",
        "candidatecontactdetailid": email.candidatecontactdetailid,
        "oldcontactdetailvalue": "null",
        "newcontactdetailvalue": email.email
      }
      this.candidateservice.makeContactsPrimary(data).subscribe((res: any) => {
        if (res.status == 'success') {
          this.EditContactDetails()
        }
      })
    }
    else {
      const control = <UntypedFormArray>this.contact_form.controls['contactemails'];
      for (let primaryindex = 0; primaryindex < control.length; primaryindex++) {
        control.at(primaryindex).patchValue({
          isprimary: 0
        })
      }
      control.at(i).patchValue({
        isprimary: 1
      })
    }
    this.basicdetails['primaryemailid'] = 'email'

  }


  deletecandidatemodal() {
    const confirmRef = this.modalService.open(this.deletecandidate, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  deletecandidatedetails() {
    let data = {
      "candidatenumber": this.candidateid,
      "usernumber": this._localstorageservice.getItem('usernumber'),
    }
    this.candidateservice.deletecandidatedetails(data).subscribe((res: any) => {
      if (res.status == "success") {
        this.modalService.dismissAll()
        this.dismissCandidateSlider()
        this.toastmessage('Candidate Deleted Successfully', 'success')
        this.candidateservice.createCandidateData();
      } else {
        this.toastmessage('Something Went Wrong', 'error')
      }
      this.refreshCandidateListEvent.emit("refresh");
    })
  }

  route2pricing() {
    this.modalService.dismissAll()
    this.router.navigateByUrl('/subscription/pricing')
  }

  fetchcredits() {
    // Credits come from the shared signal (populated only on login and after reveal-contact
    // succeeds, see TransactionService) - no direct call to /paymentflow/fetchcurrentplancredits.
    const res: any = { data: this.transactionservice.credits() };
    if (res.data) {
        if (res.data.isteamadmin) {
          // Here the logged in person is a Team Admin
          this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
          this.subscriptiondetails.balancebasiccontactenrichmentcredits = res.data.balancebasiccontactenrichmentcredits;
          this.subscriptiondetails.balancejdparsingcredits = res.data.pooledbalancejdparsingcredits;
          this.subscriptiondetails.balancesmartemailcredits = res.data.pooledbalancesmartemailcredits;
          this.subscriptiondetails.balancetalentpipelinecredits = res.data.pooledbalancetalentpipelinecredits;
        } else {
          if (res.data.teamadmindetails) {
            // Here the logged in person is a Team Member
            this.isteamMember = true
            this.subscriptiondetails.balancebasiccontactenrichmentcredits = res.data.balancebasiccontactenrichmentcredits;
            this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
            this.subscriptiondetails.balancejdparsingcredits = res.data.teamadmindetails.adminbalancejdparsingcredits;
            this.subscriptiondetails.balancesmartemailcredits = res.data.teamadmindetails.adminbalancesmartemailcredits;
            this.subscriptiondetails.balancetalentpipelinecredits = res.data.teamadmindetails.adminbalancetalentpipelinecredits;
          } else {
            // Here the logged in person is a normal (who does not belong to any team)
            this.subscriptiondetails.balancebasiccontactenrichmentcredits = res.data.balancebasiccontactenrichmentcredits;
            this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
            this.subscriptiondetails.balancejdparsingcredits = res.data.balancejdparsingcredits;
            this.subscriptiondetails.balancesmartemailcredits = res.data.balancesmartemailcredits;
            this.subscriptiondetails.balancetalentpipelinecredits = res.data.balancetalentpipelinecredits;
          }
        }
        this._localstorageservice.setItem('jdcredits', this.subscriptiondetails.balancejdparsingcredits)
        this._localstorageservice.setItem('tpcredits', this.subscriptiondetails.balancetalentpipelinecredits)
        this._localstorageservice.setItem('cecredits', this.subscriptiondetails.balancecontactenrichmentcredits)
        this._localstorageservice.setItem('secredits', this.subscriptiondetails.balancesmartemailcredits)

        let userData = this._localstorageservice.getItem('userdata')
        userData['balancebasiccontactenrichmentcredits'] = res.data.balancebasiccontactenrichmentcredits
        this._localstorageservice.setItem('userdata', userData)

        this.transactionservice.createPaymentData();

      }
  }

  sendmailexpiry(type) {
    let data = {
      expiredmetric: type
    }
    this.transactionservice.sendcreditexpirymail(data).subscribe()
  }

  toString(data) {
    return JSON.stringify(data)
  }

  OpenSimilarCandidate() {
    let data = {
      platformsaccessed: 'LinkedIn',
    }
    if (this.additionaldetails && this.additionaldetails.information) {
      data['preferredskills'] = this.additionaldetails.information.replace(/,/g, "; ")
    }
    if (this.experiencedetails && this.experiencedetails.length > 0) {
      let currentexp = this.experiencedetails.filter(x => { return x.iscurrent == 1 })
      if (currentexp && currentexp.length) {
        data['jobtitles'] = currentexp[0].jobtitle
        data['locations'] = currentexp[0].locationname
      } else {
        data['jobtitles'] = this.experiencedetails[0].jobtitle
        data['locations'] = this.experiencedetails[0].locationname
      }
    }
    this.candidateservice.passSimilarCandidateData(data)

    //- Clevertap View Similar event
    let ctObj = {
      "Name": this.basicdetails.firstname + " " + this.basicdetails.lastname,
      "Job title": this.basicdetails.jobtitle,
      "Company Name": this.basicdetails.companyname,
      "Source": this.basicdetails.source,
      "Location": this.basicdetails.locationname,
      "Origin": "Web app"
    }
    this.cleverTapEvent("View Similar", ctObj);
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(['searchtoolbox-v2']));
  }

  seemorecontacts(type) {
    this[type] = true
    // if(type == 'viewmoreLinks'){
    //   this.SocialLinkFilters(this.socialprofiles)
    // }
  }

  copyData(value, id?) {
    var dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = value;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    document.getElementById('copied' + id).classList.add('d-visible')
    setTimeout(() => {
      document.getElementById('copied' + id).classList.remove('d-visible')
    }, 500)
  }

  cleverTapEvent(eventName, data) {
    clevertap.event.push(eventName, data);
    console.log(eventName + " CT event");
  }

  openAddTalentpoolModal() {
    const modalRef = this.modalService.open(AddToTalentpoolComponent, { size: 'lg' as 'lg', centered: true });
    modalRef.componentInstance.candidatetoAdd = this.basicdetails
    modalRef.componentInstance.BuldCandidatetoAdd = []
    modalRef.componentInstance.type = 'candidate'
    modalRef.componentInstance.passEntry.subscribe((x) => {
      if (x == 'candidateAdded') {
        this.toastmessage('Candidate Added to Talentpool Succesfully', 'success')
        this.getCandidateDetails();
      } else if (x == 'alreadyexist') {
        this.toastmessage('Candidate has already been added to this talentpool', 'success')
      } else if (x == 'error') {
        this.toastmessage('Something went Wrong', 'error')
      }
    })
  }

  gettags() {
    this.candidateservice.gettags(this.candidateid).subscribe((res: any) => {
      this.tagList = res.candidatetags
      this.tagArray = []
      this.sendtagarray = []
      this.tagList.map(x=>{

          this.tagArray.push({action: 'update', tagid: x.tagid, tagtext: x.tagtext, candidatenumber: this.candidateid})
        //  this.tagchips.push({action: 'update', tagid: x.tagid, tagtext: x.tagtext, candidatenumber: this.candidateid})


        })
    })
  }

  createTag() {
    if (this.tagtext != null && this.tagtext != '') {
      if (GlobalService.hasHTMLTags(this.tagtext)) {
        this.tagErrorMessage = 'HTML tags are not allowed.';
        this.tags = [];
        return;
      }
      let payload = {
        tagtext: this.tagtext.replace(/'/g, "''")
      }
      const newtagtext = this.tags.filter(x=>x.tagtext.toLowerCase().trim() == this.tagtext.toLowerCase().trim())
      if(newtagtext.length > 0) {
        const tagid = this.tagArray.filter(x=>x.tagid == newtagtext[0].tagid)
        if(tagid.length > 0) {
          this.tagtext = ''
          this.autocomplete.closePanel()
        } else {
          this.tagArray.push({action: 'create', tagtext:newtagtext[0].tagtext, tagid: newtagtext[0].tagid, candidatenumber: this.candidateid})
          this.sendtagarray.push({action: 'create', tagid: newtagtext[0].tagid, candidatenumber: this.candidateid})
          this.tagtext = ''
          this.autocomplete.closePanel()
        }

      } else {
      this.candidateservice.createupdatetags(payload).subscribe((res: any) => {
        if (res.status == "success") {
          if (res.tagid) {
            const tagid = res.tagid
            this.tagArray.push({ action: 'create', tagtext: this.tagtext, tagid: tagid, candidatenumber: this.candidateid })
            this.sendtagarray.push({ action: 'create', tagid: tagid, candidatenumber: this.candidateid})
            this.tagmessage = ''

          } else {
            this.tagmessage = res.message
          }

        }

        this.tagtext = ''

      })
      }
    }
  }

  addtags() {
    if((this.tagtext == null || this.tagtext == '' || this.tagtext.trim() == '') && !this.sendtagarray.length) {
      this.tagErrorMessage = 'Tag cannot be empty. Please provide a valid tag.';
      return;
    }
    this.tagErrorMessage = '';
    if (GlobalService.hasHTMLTags(this.tagtext)) {
      this.tagErrorMessage = 'HTML tags are not allowed.';
      return;
    }

    if(this.tagtext != null && this.tagtext != '') {
      let payload = {
        tagtext: this.tagtext.replace(/'/g, "''")
      }
      const newtagtext = this.tags.filter(x=>x.tagtext.toLowerCase().trim() == this.tagtext.toLowerCase().trim())
      if(newtagtext.length > 0) {
        const tagid = this.tagArray.filter(x=>x.tagid == newtagtext[0].tagid)
        if(tagid.length > 0) {
          this.tagtext = ''
          this.autocomplete.closePanel()
        } else {
        this.tagArray.push({action: 'create', tagtext:newtagtext[0].tagtext, tagid: newtagtext[0].tagid, candidatenumber: this.candidateid})
          this.sendtagarray.push({action: 'create', tagid: newtagtext[0].tagid, candidatenumber: this.candidateid})
          this.tagtext = ''
          this.autocomplete.closePanel()
      }
    }else {
      this.candidateservice.createupdatetags(payload).subscribe((res: any) => {
        if (res.status == "success") {
          if (res.tagid) {
            const tagid = res.tagid
            this.tagArray.push({ action: 'create', tagtext: this.tagtext, tagid: tagid, candidatenumber: this.candidateid })
            this.sendtagarray.push({ action: 'create', tagid: tagid, candidatenumber: this.candidateid})
            this.tagmessage = ''

          } else {
            this.tagmessage = res.message
          }

        }
        if (this.sendtagarray.length > 0) {
          let payload = {
            tags: this.sendtagarray
          }
          this.candidateservice.updatetags(payload).subscribe((res: any) => {
            if (res.status == "success") {
              this.modalService.dismissAll()
              this.refreshCandidateListEvent.emit("refresh")

              this.toastmessage('Tags updated successfully', 'success')
              this.gettags()

              document.getElementById('dropdowndata').style.display = 'none'
            } else {
              this.modalService.dismissAll()
              this.toastmessage('Some error occured', 'error')
            }
          })

      }
     })
    }

    } else {
      if (this.sendtagarray.length > 0) {
        let payload = {
          tags: this.sendtagarray
        }
        this.candidateservice.updatetags(payload).subscribe((res: any) => {
          if (res.status == "success") {
            this.modalService.dismissAll()
            this.refreshCandidateListEvent.emit("refresh")
            this.toastmessage('Tags updated successfully', 'success')
            this.gettags()

            document.getElementById('dropdowndata').style.display = 'none'
          } else {
            this.modalService.dismissAll()
            this.toastmessage('Some error occured', 'error')
          }
        })

    }
    }

  }

  unselect(tagid) {
    let payloadtagarray = []
    payloadtagarray.push({ action: 'archive', tagid: tagid, candidatenumber: this.candidateid })
    if (payloadtagarray.length > 0) {
      let payload = {
        tags: payloadtagarray
      }
      this.candidateservice.updatetags(payload).subscribe((res: any) => {
        if (res.status == "success") {
          this.modalService.dismissAll()
          this.toastmessage('Tags updated successfully', 'success')
          this.gettags()
          this.refreshCandidateListEvent.emit("refresh")


        } else {
          this.modalService.dismissAll()
          this.toastmessage('Some error occured', 'error')
        }
      })
    }
  }

  remove(tagid) {
    this.tagArray = _.reject(this.tagArray, { tagid: tagid })
    this.sendtagarray.push({action: 'archive', tagid: tagid, candidatenumber: this.candidateid })
  }

  showdropdown() {
    document.getElementById('dropdowndata').style.display = 'block'
    this.tagArray = []
    this.tagtext = ''
    this.tagchips = []
    this.sendtagarray = []
    this.gettags();
    this.hideelement = true;
    this.tagErrorMessage = '';
  }
  closedropdown(){
    document.getElementById('dropdowndata').style.display = 'none'
    this.hideelement = false;
    this.tagErrorMessage = '';
  }

searchTags(event) {
  this.tagErrorMessage = '';
  let data = event.replace(/'/g, "''");
  if (GlobalService.hasHTMLTags(data)) {
    this.tagErrorMessage = 'HTML tags are not allowed.';
    this.tags = [];
    return;
  }

    this.candidateservice.gettypedtags(data).subscribe((res:any)=>{
      this.tags = res.message;
    })
}

addTag(data) {
  let tagid = []
  tagid = this.tagArray.filter(x=>x.tagid == data.tagid)
  if(tagid.length == 0) {
    this.tagArray.push({action: 'create', tagtext:data.tagtext, tagid: data.tagid, candidatenumber: this.candidateid})
    this.tagchips.push({action: 'create', tagtext:data.tagtext, tagid: data.tagid, candidatenumber: this.candidateid})
    this.sendtagarray.push({action: 'create', tagid: data.tagid, candidatenumber: this.candidateid})
    this.tagchips = _.uniq(this.tagchips, 'tagid')
  }

}

showmore() {
  document.getElementById('tagdata').style.height="100%"
  document.getElementById('tagdata').style.height="auto"
  this.tagmore = true
}

showless() {
  document.getElementById('tagdata').style.height="65px"
  document.getElementById('tagdata').style.height="hidden"
  this.tagmore = false
}

getnotesdata(event) {
  if(event == 'deleted') {
    this.getCandidateDetails()
    this.refreshCandidateListEvent.emit("refresh")

  }
}

openUrl(link, type) {
  if (!link || !type)
    return;
  if (link.startsWith("www.linkedin") || link.startsWith("www.facebook") || link.startsWith("www.twitter") || link.startsWith("www.github"))
    link = "https://" + link;
  else if (type == 'linkedin' && !(link.includes("https://www.linkedin") || link.includes("https://linkedin") || link.includes("https://in.linkedin") || link.includes("http://linkedin") || link.includes("http://www.linkedin")))
    link = "https://www." + link;
  else if (type == 'facebook' && !(link.includes("https://www.facebook") || link.includes("https://facebook") || link.includes("https://in.facebook") || link.includes("http://facebook") || link.includes("http://www.facebook")))
    link = "https://www." + link;
  else if (type == 'twitter' && !(link.includes("https://www.twitter") || link.includes("https://twitter") || link.includes("https://in.twitter") || link.includes("http://twitter") || link.includes("http://www.twitter")))
    link = "https://www." + link;
  else if (type == 'github' && !(link.includes("https://www.github") || link.includes("https://github") || link.includes("https://in.github") || link.includes("http://github") || link.includes("http://www.github")))
    link = "https://www." + link;
    else if (type == 'website'){
      link = "https://www." + link;
    }
  window.open(link, "_blank")
}


  getUniqueContactProviders(data){
    // Iterate through the data and collect unique enrichedvia values
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
          const items = data[key];
          items.forEach(item => {
              if (item.enrichedvia && !this.uniqueEnrichedvia.includes(item.enrichedvia)) {
                  this.uniqueEnrichedvia.push(item.enrichedvia);
              }
          });
      }
    }
  }

  removeKeysFromArrayObjects(obj, keysToRemove) {
    const order = ["pipl", "rocketreach", "pdl", "nymblr"];
    const sortedData = {}

    order.forEach(key => {
        sortedData[key] = obj[key];
    });

    for (const key in sortedData) {
      if (keysToRemove.includes(key)) {
          delete sortedData[key];
      }
    }

    return sortedData;
  }

  returnZero() {
    return 0
  }

private getFormattedTenure(tenure: number) {
  const totalYears = Math.floor(tenure);
  const totalMonths = Math.round((tenure - totalYears) * 12);
  if (totalYears > 0 && totalMonths > 0) {
    return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'} ${totalMonths} Mths`;
  } else if (totalYears > 0 && totalMonths == 0) {
    return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'}`;
  } else if (totalYears == 0 && totalMonths > 0) {
    return `${totalMonths} Mths`;
  } else {
    return '';
  }
}

getTaggeddata(event) {
  if(event) {
    this.getCandidateDetails();
  }
}

  getWhatsappLink(phonenumber: string) {
    return `https://api.whatsapp.com/send/?phone=${phonenumber.trim().replace(/[\+\-\s]/g, '')}`;
  }

  getLastSeenText(contactDetailObj: any) {
    return (contactDetailObj?.pipl_validsince && contactDetailObj?.pipl_validsince != 'undefined' && Math.abs(moment().diff(contactDetailObj?.pipl_validsince, 'year')) < 10) ? 'Last seen ' + moment(contactDetailObj.pipl_validsince, 'YYYY-MM-DD').fromNow() : '';
  }

  copyToClipboard(content: string) {
    let dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = content;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    this.successMessage = "Contact detail copied succesfully"
    setTimeout(() => this.successMessage = '', 3000);
  }

  markContactValidity(contactDetailObject, isValid) {
    const payload = {
      candidatenumber: this.candidateid,
      usernumber: this._localstorageservice.getItem('usernumber'),
      isvalid: Number(isValid),
      candidatecontactdetailid: contactDetailObject.candidatecontactdetailid
    }
    this.personSearchService.markContactValidity(payload).subscribe((res: any) => {
      if(res && res.status === 'success') {
        this.successMessage = "Marked validity for contact successfully";
        setTimeout(() => this.successMessage = '', 3000);
      }
    }, (err: any) => {
      console.log("markContactValidity() err", err);
      this.errorMessage = "Something went wrong";
      setTimeout(() => this.errorMessage = '', 3000);
    }).add(() => this.getAllContactDetails());
  }

  getProvidername(key){
    if(key != null){
      if(key.toString().toLowerCase() === 'pipl'){
        return 'Pipl'
      }else if(key.toString().toLowerCase() === 'pdl'){
        return 'People Data Labs'
      }else if(key.toString().toLowerCase() === 'rocketreach'){
        return 'RocketReach'
      }else if(key.toString().toLowerCase() === 'nymblr'){
        return 'Nymblr'
      }
    }
  }

  sendMessagetoChrome() {
    let chromeid = localStorage.getItem('extensionID');
    let isExtensioninstalled
    if (chromeid) {
      try {
        window['chrome'].runtime.sendMessage(chromeid, { action: 'refreshExtension', candidateNumber: this.candidateNumber }, function (res) {
          if (res && res.similarCandidateData) {
            isExtensioninstalled = true
          }
        });
      } catch (error) {
        if (error) {
          isExtensioninstalled = false
        }
        console.error('Here is the error message', error);
      }
      setTimeout(() => {
        this.isExtensioninstalled = isExtensioninstalled
      }, 500)
    }
  }

  clearDownDivdata(event){
    if(event.isTrusted){
      this.colvillform.patchValue(null);
      this.webbtreeIntroForm.patchValue(null);
      this.showAllDivData=false;
      this.showSuccessfulData=false;
      this.isWebbtreeIntroductionChecked = false
    }

  }

  showHideFullDiv(event){
    if(event.isTrusted){
      this.option = ''
      this.showAllDivData=true;
      this.showSuccessfulData=false;
      this.webbtreeIntroForm.patchValue(null);
      this.isWebbtreeIntroductionChecked = false;
    }
  }


  checkedInput(checkboxvalue: string): void {
    this.showRequestSpinner = false;
    const index = this.selectedInputValues.indexOf(checkboxvalue);

    if (index !== -1) {
      this.selectedInputValues.splice(index, 1);
    } else {
      this.selectedInputValues.push(checkboxvalue);
    }

    this.personalContactChecked = this.selectedInputValues.includes('contactnumber');
    this.personalEmailChecked = this.selectedInputValues.includes('personalemail');

  }

  makeContractRequest(event){

    // if(this.personalContactChecked || this.personalEmailChecked){
      this.showRequestSpinner = true;
      const userData = this._localstorageservice.getItem('userdata')

      let candidateDetailsData = {
        elasticid: this.candidateelasticid,
        source: this.option
      }

      const obj = { elasticid: this.candidateelasticid , contactrequested : this.selectedInputValues }

      this.requestContract.getRequestContract(obj).subscribe((res:any)=>{

          if(res.status == "success"){
            this.showRequestSpinner = false;
            this.showAllDivData=false;
            this.showSuccessfulData=true;
            this.fetchcredits()
          }else{
            this.showAllDivData=true;
            this.showSuccessfulData=false;
            this.showRequestSpinner = false;
            this.toastmessage('You don`t have enough credits!', 'error')
          }
      })
    // }
  }

  exportToPDF() {
    this.personSearchService.exportCandidateProfileToPDF({ candidatenumber: this.candidateid }).subscribe((res: any) => {
      if(res) {
        if(res.status === 'failure') {
          this.errorMessage = 'Error occured while exporting to PDF';
        } else {
          const blobFile = new Blob([res], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blobFile);
          const downloadLink = document.createElement("a");
          downloadLink.style.display = "none";
          document.body.appendChild(downloadLink);
          downloadLink.setAttribute("href", blobUrl);
          downloadLink.setAttribute("download", `${(this.basicdetails.firstname || '').replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())} ${(this.basicdetails.lastname || '').replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())}.pdf`);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          this.successMessage = 'Exported to PDF successfully'
        }
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 5000);
      }
    });
  }

  isObjectEmpty(obj) {
    if(obj){
      return Object.keys(obj).length === 0;
    }
  }





  showHideFullDivWebbtreeIntro(event){
    if(event.isTrusted){
      // this.webbtreeIntroRadioForm = this.fb.group({
      //   option: [""]
      // });
      this.isWebbtreeIntroductionChecked = true;
      this.option = ''
      this.showAllDivDataWebbtreeIntro=true;
      this.showSuccessfulDataWebbtreeIntro=false;
      this.colvillform.patchValue(null);
    }
  }



  makeWebbtreeIntroductionRequest(){
    if(this.isWebbtreeIntroductionChecked === false){
      return;
    }
    this.showwebbtreeintrospinner = true;
    const obj = { elasticid: this.candidateelasticid}
    this.personSearchService.makeRequestContact(obj).subscribe((res:any)=>{
        if(res.status == "success"){
          this.showwebbtreeintrospinner = false;
          this.showAllDivDataWebbtreeIntro=false;
          this.showSuccessfulDataWebbtreeIntro=true;
          this.fetchcredits()
        }else{
          this.showAllDivDataWebbtreeIntro=true;
          this.showSuccessfulDataWebbtreeIntro=false;
          this.showwebbtreeintrospinner = false;
          this.toastmessage('You don`t have enough credits!', 'error')
        }
    })

  }

  checkProperties(obj): boolean {
    if(obj){
      return obj.work_email && obj.personal_email && obj.phone;
    }
  }

  checkIfProviderisEmptyAndNoPreviewResponse(data): boolean {
    let nymblrExists = false;
    // let piplExists = false;

    let canShow = false;
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
          if (key === 'nymblr') {
              nymblrExists = true;
          }
          if (this.checkProperties(data[key])) {
             canShow = true;
          }else{
            canShow = false;
          }
      }
    }
    if(nymblrExists || canShow){
      return true;
    }else{
      return false;
    }

  }

  onTabChange(tab) {
    this.tabtoShow = tab;
  }

  /**
   * Handle events of all tabs
   * @param event
   */
  childEventsHandler(event) {
    const action = event.action;
    const data = event.data;
    switch (action) {
      case 'refresh': this.refreshCandidateListEvent.emit('refresh');
      break;
      case 'edit-experience': this.EditExperienceDetails(data);
      break;
      case 'delete-experience': this.openDeleteExperienceModal(data);
      break;
      case 'edit-education': this.EditEducationDetails(data);
      break;
      case 'delete-education': this.openDeleteEducationModal(data);
      break;
    }
  }

  openAddToEmailCampaign(){
    // if(data?.basicdetails?.candidatenumber)
    const modalRef = this.modalService.open(this.addCandidateToEmailCampaign, { size: 'xs' as 'lg', centered: true, backdrop : 'static', keyboard : false });
      // this.selectedcandidate.push(data.basicdetails.candidatenumber);
  }

  onTypeAheadSearch(event: string): void {
    const query = event;
    this.emailCampaignService.getCampaigns({campaign_name: query, created_by: this._localstorageservice.getItem('userdata').userid, 'status[]': [1,2], typeahead: true }).subscribe((data) => {
      this.campaignList = data['data'];
    });
  }

  // Add this function to handle the selection from the typeahead
  onCampaignSelected(value): void {
    this.selectedCampaign = value;
    this.campaign_input.setValue(value.campaign_name);
  }

  addToEmailCampaign() {
    // const campaign_id = this.campaignid;
    this.isLoadingEmailCampaignApi = true;
    this.campaign_input.markAllAsTouched();
    if(this.campaign_input.valid && this.selectedCampaign){
      let tempFirstName = (this.basicdetails?.firstname) ? this.basicdetails.firstname : '';
      let tempLastName = (this.basicdetails?.lastname) ? this.basicdetails.lastname : '';
      let payloadArray = [{
            firstname: tempFirstName,
            target_name: tempFirstName + ' ' + tempLastName,
            target_id: this.candidateIdentifier,
            target_meta: JSON.stringify({
              "candidatenumber": this.basicdetails.candidatenumber,
              "title": this.basicdetails.jobtitle && this.basicdetails.jobtitle.length ? this.basicdetails.jobtitle : null,
              "elastic_id": (this.basicdetails?.elastic_id) ? this.basicdetails.elastic_id : null,
            }),
            target_email:null,
            is_active: true,
            created_on: new Date().toISOString(),
            updated_on: new Date().toISOString()
          }]
      payloadArray = payloadArray.filter(x => x);
      Promise.all(payloadArray.map(async (x) => {
        // Wait for the async operation to complete
        x.target_email = await this.getContactDetails(JSON.parse(x.target_meta).candidatenumber, this.selectedCampaign['email_pref']);
        // Return the updated payload object to the Promise.all() call
        return x;
      })).then((updatedPayloadArray) => {

        this.emailFoundCount = 0;

        if (!updatedPayloadArray.length) {
          this.isLoadingEmailCampaignApi = false;
          this.closeActiveModal();
          this.toastmessage("No valid email found for the candidate based on the selected campaign's email preference", 'error');
          return;
        }

        updatedPayloadArray.forEach(element => {
          if(element.target_email)
            this.emailFoundCount++;
        }
        );
        this.campaignName = this.campaign_input.value;

        if(!this.basicdetails?.is_unsubscribed){
          this.emailCampaignService.createTarget(this.selectedCampaign.campaign_id, updatedPayloadArray).subscribe((res: any) => {
           this.isLoadingEmailCampaignApi = false;
           if (res.status == 'success') {
             if (res.data && res.data.length) {
               this.closeActiveModal();
                const modalRef = this.modalService.open(this.addToEmailCampaignWithViewCampaign, { windowClass:'modalastoastmessage', size: 'xs' as 'lg', centered: false, backdrop: false, keyboard: false } )
              setTimeout(() => {
                modalRef.close();
              }, 5000);
                /**
               * add email campaign
               */
              const emaailCampaignParams = {
                "User ID": this._localstorageservice.getItem('userdata').userid,
                "Candidate ID": this.basicdetails?.elastic_id,
                "Campaign Name": this.campaign_input.value
              }
              clevertap.event.push('Add Candidate to Email Campaign', emaailCampaignParams);
               if (this.emailFoundCount !== updatedPayloadArray.length) {

                  // new payload for openDetail modal that contains mapping of candidate number elastic_id and campaign_targe_id for bulk reveal
                  const bulkRevealPayLoad = {
                   source: this.enrichedfrom,
                   candidates: [],
                   campaign_id: this.selectedCampaign.campaign_id
                 }
                 res.data.map((arr) => {
                   if(!arr?.target_email){
                     bulkRevealPayLoad.candidates.push(
                       {
                         elastic_id: JSON.parse(arr?.target_meta || '{}')?.elastic_id,
                         // candidatenumber: JSON.parse(arr?.target_meta || '{}')?.candidatenumber,
                         campaign_target_id: arr.campaign_target_id
                       }
                     );
                   }
                 })
                 this.openDetailsModal(this.selectedCampaign.campaign_id, bulkRevealPayLoad, this.emailFoundCount, updatedPayloadArray.length);
               }
             }
             else {
               this.closeActiveModal()
               this.toastmessage("Candidate already present in selected campaign", 'error')
             }
             // this.selectedcandidate = [];
           }
           //show toast message if candidate addition failed
           else if (res.status == 'failure') {
             this.closeActiveModal()
             this.toastmessage("candidate addition failed", "error");
           }
         }, (error: HttpErrorResponse) => {
                       this.isLoadingEmailCampaignApi = false;
                       if (error.status === 400 && error.error && Reflect.has(error.error, 'remainingTargets')) {
                         const remainingTargets = error.error.remainingTargets;
                         this.toastmessage(`Only ${remainingTargets} candidate(s) can be added to the campaign as you are nearing the campaign limit`, "error");
                       } else {
                         this.toastmessage("Something went wrong", "error");
                       }
                       this.closeActiveModal();
                     });
        }else{
          this.closeActiveModal();
          this.toastmessage("Unsubscribed from Email Campaign", 'error');
        }
      }).catch((error) => {
        this.toastmessage("An error occurred during candidate addition", "error");
        this.closeActiveModal()

      });
    }
    else{
      this.isLoadingEmailCampaignApi = false;
    }
  }


  openAddToScreenAiModal() {
    this.modalService.open(this.addCandidateToScreenAiModal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  getAllScreenAIJobs() {
    // Trigger valueChanges by emitting the current value
    if (!this.job_input.value) {
      this.job_input.setValue('', { emitEvent: true });
    }
  }

  /**
   * Check if a job is currently being screened.
   */
  isScreeningInProgress(job: any){
    return job.batch_status === 'pending';
  }

  /**
   * Get tooltip text for a job.
   */
  getTooltipText(job: any){
    if(job.batch_status === 'pending'){
      return 'Screening in progress, please try after sometime';
    }
    return '';
  }

  searchJob(event: any): void {
    const query = (event.target.value || '').trim();
    this.atsResumeScreenService.getAllScreenAIJobsBySource(query, 'create').subscribe((res: any) => {
      if (res.status === 'success') {
        this.jobList = query
          ? (res.data || []).filter((j: any) => j.name && j.name.toLowerCase().includes(query.toLowerCase()))
          : (res.data || []);
      }
    });
  }

  onJobSelected(value: any): void {
    this.selectedJob = value;
    this.job_input.setValue(value.name);
  }

  redirectToScreenAi(): void {
    if (this.selectedJob && this.selectedJob.ats_job_id) {
      this.router.navigate([`/resume-screen/candidate-listing/${this.selectedJob.ats_job_id}`]);
    } else {
      this.router.navigate(['/resume-screen']);
    }
    this.closeActiveModal();
  }

  /**
   * Add the current candidate (this.data) to a ScreenAI job.
   * Performs a duplicate check first (per candidate), then calls the add API.
   */
  addToScreenAi(): void {
    this.job_input.markAllAsTouched();
    if (!this.job_input.valid || !this.selectedJob) {
      return;
    }
    this.isLoadingScreenAiApi = true;

    // this.data is the single candidate from @Input()
    const candidateToAdd = this.basicdetails;
    const candidateDetails = [{elastic_id: candidateToAdd.elastic_id, firstname: candidateToAdd.firstname, lastname: candidateToAdd.lastname, companyname: candidateToAdd.companyname, title: candidateToAdd.jobtitle}];
    const dupPayload = {
      candidateDetails,
      jobnumber: this.selectedJob.jobnumber
    };

    this.atsResumeScreenService.checkDuplicateCandidate(dupPayload).toPromise()
      .then((res: any) => {
        const results = res?.duplicateIds;

        if (results.length > 0) {
          // All are duplicates — do not proceed
          this.isLoadingScreenAiApi = false;
          this.screenAiDuplicateCheckDone = true;
          this.addCandidateSuccess = false;
          this.postAddMssg = `${results.length === 1 ? 'This candidate is' : `${results.length} candidates are`} already present in this ScreenAI job. no new candidates will be added.`;
          return;
        }

        // No duplicate — proceed to add
        const elasticid = candidateToAdd.elastic_id;
        const source = candidateToAdd.source || 'Talent Discovery';
        const addPayload = {
          jobnumber: this.selectedJob.jobnumber,
          candidateinfo: [{ elasticid, source }],
          calledfrom: "talentpool"
        };
        this.atsResumeScreenService.addCandidatesToScreenAI(addPayload).subscribe((addRes: any) => {
          this.isLoadingScreenAiApi = false;
          this.screenAiDuplicateCheckDone = true;
          if (addRes && addRes.status === 'success') {
            this.addCandidateSuccess = true;
            this.postAddMssg = 'Candidate added to ScreenAI successfully.';
          } else {
            this.addCandidateSuccess = false;
            this.postAddMssg = (addRes && addRes.message) ? addRes.message : 'Something went wrong while adding to ScreenAI. Please try again.';
          }
        }, (err) => {
          console.log(err)
          this.isLoadingScreenAiApi = false;
          this.screenAiDuplicateCheckDone = true;
          this.addCandidateSuccess = false;
          this.postAddMssg = 'Something went wrong while adding to ScreenAI. Please try again.';
        });
      })
      .catch((err) => {
        console.log(err)
        this.isLoadingScreenAiApi = false;
        this.screenAiDuplicateCheckDone = true;
        this.addCandidateSuccess = false;
        this.postAddMssg = 'Something went wrong while adding to ScreenAI. Please try again.';
      });
  }

  getContactDetails(candidateid, emailPref) {
    return new Promise((resolve, reject) => {
      let data = {
        "usernumber": this._localstorageservice.getItem('usernumber'),
        "candidatenumber": candidateid,
      };

      this.candidateservice.getContactDetails(data).subscribe(
        (res: any) => {
          if (res.status === 'success') {
            let personalPref_email = '';
            let professionalPref_email = '';
            let targetEmailFound = '';
            const existingContactDetails = res?.data?.emails;
            if (existingContactDetails && existingContactDetails.length) {

              personalPref_email = this.emailCampaignService.setPriorityBasedTargetEmail(existingContactDetails, 'personal')
              professionalPref_email = this.emailCampaignService.setPriorityBasedTargetEmail(existingContactDetails, 'professional')

              switch (emailPref) {
                case 1: targetEmailFound = personalPref_email;
                  break;
                case 2: targetEmailFound = professionalPref_email;
                  break;
                case 3: targetEmailFound = personalPref_email ? personalPref_email : professionalPref_email;
                  break;
                case 4: targetEmailFound = professionalPref_email ? professionalPref_email : personalPref_email;
                  break;
              }
            }
            if (targetEmailFound) {
              resolve(targetEmailFound);
            } else {
              // reject("email not found for the candidate.");
              resolve(null);
            }
          } else {
            reject("Error fetching contact details for the candidate.");
          }
        },
        (error) => {
          reject("An error occurred while fetching contact details.");
        }
      );
    });
  }
  openDetailsModal(campaign_id, payload, emailsFound,total_target){
    this.closeActiveModal()
    const modalRef =  this.modalService.open(BulkRevealModalComponent, { size: 'xs' as 'lg', centered: true});
    modalRef.componentInstance.campaign_id = campaign_id;
    modalRef.componentInstance.payload = payload;
    modalRef.componentInstance.emailsFound = emailsFound;
    modalRef.componentInstance.campaignDetails = this.selectedCampaign;
    modalRef.componentInstance.total_target = total_target;
    modalRef.componentInstance.calledFor = 'email-campaign';
  }
  closeActiveModal(){
    this.campaign_input.markAsUntouched();
    this.campaign_input.markAsPristine();
    this.campaign_input.reset();
    this.screenAiDuplicateCheckDone = false;
    this.isLoadingScreenAiApi = false;
    this.postAddMssg = '';
    this.addCandidateSuccess = false;
    this.selectedJob = null;
    this.job_input.markAsUntouched();
    this.job_input.markAsPristine();
    this.job_input.reset();
    this.jobList = []
    this.modalService.dismissAll()
  }
  getEmailPref(data){
    if(data==1){
      return 'personal';
    }
    else if(data==2){
      return 'professional';
    }
    else if(data==3){
      return 'FirstPersonal';
    }
    else{
      return 'FirstProfessional';
    }
  }

  getRevealContactStatus(event) {
    this.revealStatusEventEmitter.emit(event);
  }

    redirectToEmailCampaign(campaign_id){
    this.router.navigateByUrl(`email-campaign/target-listing/${campaign_id}`);
    }
}
